<template>

  <div class="generate-wrapper">

  <div

    v-if="!workspaceDisabled && showMentionMenu && (filteredMentions.length || (isSeedancePlatform && hasVolcAssetViewPermission))"

    class="mention-list-popover fade-in"

    :style="mentionMenuStyle"

    @mouseleave="onMentionMouseLeave"

  >

    <div class="mention-list-header" @mousedown.prevent>
      <span>素材列表</span>
      <button v-if="isSeedancePlatform && hasVolcAssetViewPermission" type="button" class="mention-refresh"
        aria-label="刷新素材列表" :title="volcAssetsLoading ? '正在刷新素材' : '刷新素材列表'"
        :disabled="volcAssetsLoading" :aria-busy="volcAssetsLoading"
        @click.stop="loadVolcAssets({ force: true })">
        <el-icon :class="{ 'is-loading': volcAssetsLoading }"><Refresh /></el-icon>
      </button>
    </div>
    <div ref="mentionMenuRef" class="mention-list-body" @scroll.passive="onMentionListScroll">
    <div v-if="volcAssetsError" class="mention-list-status is-error" role="status">{{ volcAssetsError }}</div>
    <div v-else-if="!filteredMentions.length" class="mention-list-status" role="status">
      {{ volcAssetsLoading ? '正在加载素材…' : '暂无匹配素材' }}
    </div>
    <div aria-hidden="true" :style="{ height: mentionWindowTop + 'px' }" />
    <div

      v-for="{ item, index } in visibleMentionRows"

      :key="item.id || index"

      class="mention-item"

      :class="{ 'active': index === mentionIndex }"

      @mousedown.prevent="selectMention(item)"

      @mouseenter="onMentionMouseEnter(index)"

      @mouseleave="onMentionMouseLeave"

    >

      <template v-if="item.type === 'image'">

        <ReferenceThumbnail v-if="item.coverUrl" :src="item.coverUrl" compact class="mention-thumb" />

        <span class="mention-uuid" :title="'@' + item.uuid">@{{ item.uuid }}</span>

        <span class="mention-badge local-badge">本地</span>

        <span class="mention-badge" v-if="item.instructionValue">{{ item.instructionValue }}</span>

      </template>

      <template v-else-if="item.type === 'video'">

        <ReferenceThumbnail v-if="item.coverUrl" :src="item.coverUrl" compact media-type="video" class="mention-thumb" />

        <span class="mention-uuid" :title="'@' + item.uuid">@{{ item.uuid }}</span>

        <span class="mention-badge local-badge">本地</span>

      </template>

      <template v-else-if="item.type === 'audio'">

        <el-icon class="mention-audio-icon"><Headset /></el-icon>

        <span class="mention-uuid" :title="'@' + item.uuid">@{{ item.uuid }}</span>

        <span class="mention-badge local-badge">本地</span>

        <span class="mention-info" v-if="item.instructionValue">{{ item.instructionValue }}</span>

      </template>

      <template v-else-if="item.type === 'volc-asset'">

        <ReferenceThumbnail v-if="item.coverUrl && item.assetType === 'Image'" :src="item.coverUrl" compact class="mention-thumb" alt="" />

        <ReferenceThumbnail v-else-if="item.coverUrl && item.assetType === 'Video'" :src="item.coverUrl" compact media-type="video" class="mention-thumb" />

        <el-icon v-else-if="item.assetType === 'Video'" class="mention-audio-icon"><VideoCamera /></el-icon>

        <el-icon v-else-if="item.assetType === 'Audio'" class="mention-audio-icon"><Headset /></el-icon>

        <el-icon v-else class="mention-audio-icon"><Picture /></el-icon>

        <span class="mention-uuid" :title="item.name || item.uuid">{{ item.name || item.uuid }}</span>

        <span
          class="mention-badge volc-badge"
          :class="item.assetType === 'Video' ? 'mention-badge-video' : item.assetType === 'Audio' ? 'mention-badge-audio' : item.isRealPerson ? 'mention-badge-person' : 'mention-badge-portrait'"
        >{{ item.assetType === 'Video' ? '视频' : item.assetType === 'Audio' ? '音频' : item.isRealPerson ? '真人' : '人像' }}</span>

      </template>

      <template v-else>

        <span class="mention-uuid" :title="'@' + item.uuid">@{{ item.uuid }}</span>

        <span class="mention-info" v-if="item.instructionValue">({{ item.instructionValue }})</span>

      </template>

    </div>
    <div aria-hidden="true" :style="{ height: mentionWindowBottom + 'px' }" />
    </div>

  </div>



  <div class="generate-container" :class="{ 'is-generating': generating, 'is-drag-over': isDragOver, 'is-resizing': isPanelResizing, 'workspace-disabled': workspaceDisabled }" @dragenter.prevent="onDragOver" @dragover.prevent="onDragOver" @dragleave.prevent="onDragLeave" @drop.prevent="handleContainerDrop">

    <div v-if="workspaceDisabled" class="workspace-required-notice" role="status">
      <el-icon><WarningFilled /></el-icon>
      <span>请选择工作空间</span>
    </div>

    <div class="generate-panel-content" :inert="workspaceDisabled ? '' : null" :aria-disabled="workspaceDisabled">
    <div class="studio-composer-heading">
      <strong>视频生成</strong>
      <div class="studio-composer-actions">
        <el-tooltip v-if="nonAssetItems.length > 0 && hasVolcAssetUploadPermission" content="上传为资产" placement="top">
          <button type="button" class="asset-library-trigger" aria-label="上传为资产"
            :disabled="workspaceDisabled || generating" @click="openUploadAsAssetDialog"><el-icon><Upload /></el-icon></button>
        </el-tooltip>
        <button type="button" class="asset-library-trigger asset-library-folder" aria-label="打开资产库" title="资产库"
          :disabled="workspaceDisabled || generating || hasUploadingAssets || !isSeedancePlatform" @click="openAssetLibrary">
          <el-icon><FolderOpened /></el-icon>
        </button>
      </div>
    </div>

    <AssetLibraryDialog v-model="assetLibraryVisible" :items="assetLibraryItems" :script-id="scriptId"
      :limits="assetLibraryLimits" :is-wan="usesPublicReferenceUrls" :loading="volcAssetsLoading" :error="volcAssetsError"
      @add="addLibraryReferences" @deleted="onLibraryAssetDeleted" @reload="loadVolcAssets({ force: true })" />

    <div
      class="generate-resize-handle"
      role="separator"
      aria-orientation="vertical"
      title="拖动调整生成面板宽度"
      @mousedown.prevent="startPanelResize"
    >
      <span></span>
    </div>

    <div v-if="isDragOver" class="drag-over-overlay">
      <div class="drag-over-inner">
        <el-icon class="drag-over-icon"><Upload /></el-icon>
        <span class="drag-over-text">松开即可上传文件</span>
      </div>
    </div>

    <div v-if="generating" class="generating-overlay">

      <div class="generating-spinner">

        <el-icon class="custom-spin"><Loading /></el-icon>

        <span>任务提交中...</span>

      </div>

    </div>

    


    <div class="generate-form" :class="{ 'expanded-layout': isExpandedMode, 'has-reference-assets': isSeedancePlatform }">

      <div class="prompt-section">

      <div v-if="isExpandedMode" class="prompt-section-header">
        <el-icon class="section-header-icon"><MagicStick /></el-icon>
        <span>提示词</span>
      </div>

      <div class="prompt-input-wrapper">

        <el-upload

          v-if="!isSeedancePlatform"

          :action="''"

          :auto-upload="false"

          :show-file-list="false"

          :on-change="onImageChange"

          accept="image/*"

          class="upload-button-container"

          :disabled="workspaceDisabled || !platformAvailable || generating || imageUploading"

        >

          <template #trigger>

            <div class="image-preview-wrapper circle-preview" :class="{ 'hide-preview': isExpandedMode }">

              <ReferenceThumbnail v-if="inputReferenceLocal" :src="inputReferenceLocal" alt="缩略图" class="image-preview" />

              <div v-if="inputReferenceLocal">

                <div v-if="imageUploading" class="preview-overlay">

                  <el-icon class="custom-spin"><Loading /></el-icon>

                </div>

                <div v-else class="preview-overlay" @click.stop="removeImage">

                  <el-icon><Delete /></el-icon>

                </div>

              </div>

              <div v-else class="upload-icon-button">

                <el-icon v-if="imageUploading" class="custom-spin"><Loading /></el-icon>

                <el-icon v-else><Plus /></el-icon>

              </div>

            </div>

          </template>

        </el-upload>

        

        <div class="prompt-input-container" :style="promptContainerStyle">



          <Teleport to="body">

          <Transition name="preview-fade">

            <div

              v-if="previewCover.show"

              :key="`${previewCover.source}-${previewCover.type}-${previewCover.url}`"

              class="mention-media-preview"

              :class="[previewCover.type, previewCover.source === 'asset-thumb' ? 'asset-thumb-preview' : previewCover.source, { 'has-reference-name': previewCover.name }]"

              :style="previewCover.style"

              @mouseenter="onPreviewMouseEnter"

              @mouseleave="onPreviewMouseLeave"

              @pointerdown.stop="onPreviewPointerDown"

              @click="openFullscreenPreview"

            >

              <div v-if="previewCover.name" class="preview-reference-name" :title="previewCover.name" @click.stop>{{ previewCover.name }}</div>

              <div v-if="previewCover.loadError || (previewCover.type === 'image' && !previewImageUrl)" class="preview-unavailable">
                <el-icon class="preview-unavailable-icon"><WarningFilled /></el-icon>
                <span>{{ previewUnavailableText }}</span>
              </div>

              <video v-else-if="previewCover.type === 'video'" ref="previewVideoRef" :src="previewCover.url" :poster="referenceThumbnailUrl(previewCover.url, 'video')" preload="none" controls muted playsinline class="preview-video" @error="handlePreviewMediaError" @click.stop />

              <div v-else-if="previewCover.type === 'audio'" class="preview-audio-wrapper" @click.stop>

                <el-icon class="preview-audio-icon"><Headset /></el-icon>

                <audio ref="previewAudioRef" :src="previewCover.url" preload="none" controls class="preview-audio" @error="handlePreviewMediaError" @click.stop />

              </div>

              <img v-else :src="previewImageUrl" :style="{ width: previewImageSize.width + 'px', height: previewImageSize.height + 'px' }" :crossorigin="getOssImageCrossorigin(previewImageUrl)" decoding="async" @load="handlePreviewImageLoad" @error="handleImageError" alt="Cover" class="preview-img" />
              <div class="preview-fullscreen-hint">
                <el-icon><ZoomIn /></el-icon>
              </div>

            </div>

          </Transition>

          </Teleport>

          

          <div 

            ref="innerWrapperRef"

            class="input-inner-wrapper" 

            :class="{ 'expanded': isExpandedMode }"

            :style="wrapperStyle"

            @mousedown="handleWrapperMouseDown"

          >

            <div 

              v-if="localRemark" 

              class="remark-tab-bar"

              :class="{ 'active': isExpandedMode }"

              @click.stop="openRemarkDialog"

            >

              <div class="tab-content">

                <el-icon class="remark-icon"><EditPen /></el-icon>

                <span class="remark-text">备注: {{ localRemark }}</span>

              </div>

              <div class="tab-bottom-mask"></div>

            </div>



            <div 

              v-if="inputReferenceLocal" 

              class="expanded-preview-area" 

              :class="{ 'visible': isExpandedMode }"

              @mousedown.prevent

            >

              <div class="big-preview-card">

                <img :src="inputReferenceLocal" class="big-preview-img" />

                <div v-if="imageUploading" class="big-preview-loading">

                  <el-icon class="custom-spin"><Loading /></el-icon>

                </div>

                <div class="big-preview-close" @click.stop="removeImage">

                  <el-icon><Close /></el-icon>

                </div>

              </div>

            </div>



            <div class="textarea-box">

              <div 

                v-if="!isExpandedMode && modelPrompt"

                class="prompt-text-ellipsis"

                v-html="formattedModelPrompt"

              ></div>

              

              <div

                ref="editorRef"

                class="rich-textarea"
                role="textbox"
                aria-label="视频提示词"
                aria-multiline="true"

                :class="{ 'transparent-text': !isExpandedMode && modelPrompt }"

                :contenteditable="!workspaceDisabled"
                :aria-disabled="workspaceDisabled"

                @input="handleEditorInput"

                @focus="handleInputFocus"

                @blur="handleInputBlur"

                @keydown="handleKeydown"

                @paste="handlePaste"

                @copy="handleEditorCopy"

                @cut="handleEditorCut"

                @click="handleEditorClick"

                @wheel="handleTextareaWheel"

                @dblclick="openRemarkDialog"

                @mouseover="handleHover"

                @mousemove="handleHover"

                @mouseout="handleHoverOut"

              ></div>

              <div v-if="!modelPrompt" class="rich-placeholder">{{ isSeedancePlatform ? '描述视频画面，粘贴图片/音频，用 @引用资源...' : '请输入视频描述...' }}</div>



            </div>



            <div v-if="modelPrompt && !generating" class="clear-btn" @click="clearPrompt">

              <el-icon><CircleClose /></el-icon>

            </div>

          </div>

        </div>

      </div>

      <div v-if="isExpandedMode" class="prompt-section-footer">
        <span class="prompt-char-count">{{ (modelPrompt || '').length }}/2000</span>
        <el-icon v-if="modelPrompt && !generating" class="prompt-clear-footer" @click="clearPrompt"><Delete /></el-icon>
      </div>

      </div><!-- /.prompt-section -->

      <div v-if="isSeedancePlatform" class="seedance-assets-bar">

        <div class="asset-group asset-reference-group" data-type="reference">

          <div class="asset-items" @scroll="handleAssetItemsScroll" @wheel="handleAssetItemsWheel" @mousemove="handleAssetMouseMove" @mouseleave="handleAssetMouseLeave">

            <div v-for="(img, idx) in seedanceImages" :key="'img-'+idx"

              :id="'seedance-img-'+idx"

              class="asset-thumb asset-thumb-image"

              :class="{ 'asset-unused': unusedSeedanceAssets.images.includes(idx), 'volc-asset-thumb': img.isVolcAsset }"
              @mouseenter="showSeedanceAssetPreview($event, img, 'image')"
              :title="img.isVolcAsset ? (img.volcAssetName || '虚拟人像') : (unusedSeedanceAssets.images.includes(idx) ? '请在描述中 @引用此资源' : '')"

            >

              <ReferenceThumbnail :src="img.isVolcAsset ? getVolcAssetCover(img) : (img.localUrl || resolveVolcCoverUrl(img.url) || img.url)" alt="图片" />

              <el-icon v-if="!img.isVolcAsset" class="asset-type-icon asset-type-image"><Picture /></el-icon>

              <span class="asset-index-badge">{{ idx + 1 }}</span>

              <span v-if="img.isVolcAsset" class="volc-asset-badge">人像</span>

              <div class="asset-thumb-overlay" @click.stop="removeSeedanceImage(idx)">

                <el-icon><Close /></el-icon>

              </div>


              <div class="asset-thumb-uploading" v-if="img.uploading">

                <el-icon class="custom-spin"><Loading /></el-icon>

              </div>

            </div>

            <template v-if="showSeedanceVideoReference">
            <div v-for="(vid, idx) in seedanceVideos" :key="'vid-'+idx"

              :id="'seedance-vid-'+idx"

              class="asset-thumb asset-thumb-video"

              :class="{ 'asset-unused': unusedSeedanceAssets.videos.includes(idx) }"
              @mouseenter="showSeedanceAssetPreview($event, vid, 'video')"
              :title="unusedSeedanceAssets.videos.includes(idx) ? '请在描述中 @引用此资源' : ''"

            >

              <ReferenceThumbnail :src="vid.localUrl || vid.url" media-type="video" class="asset-video-thumb" />

              <el-icon class="asset-type-icon asset-type-video"><VideoPlay /></el-icon>

              <span class="asset-index-badge">{{ idx + 1 }}</span>

              <div class="asset-thumb-overlay" @click.stop="removeSeedanceVideo(idx)">

                <el-icon><Close /></el-icon>

              </div>


              <div class="asset-thumb-uploading" v-if="vid.uploading">

                <el-icon class="custom-spin"><Loading /></el-icon>

              </div>

            </div>
            </template>

            <div v-for="(aud, idx) in seedanceAudios" :key="'aud-'+idx"

              :id="'seedance-aud-'+idx"

              class="asset-thumb asset-thumb-audio asset-audio-thumb"

              :class="{ 'asset-unused': unusedSeedanceAssets.audios.includes(idx) }"
              @mouseenter="showSeedanceAssetPreview($event, aud, 'audio')"
              :title="unusedSeedanceAssets.audios.includes(idx) ? '请在描述中 @引用此资源' : ''"

            >

              <el-icon class="audio-icon"><Headset /></el-icon>

              <el-icon class="asset-type-icon asset-type-audio"><Headset /></el-icon>

              <span class="asset-index-badge">{{ idx + 1 }}</span>

              <div class="asset-thumb-overlay" @click.stop="removeSeedanceAudio(idx)">

                <el-icon><Close /></el-icon>

              </div>


              <div class="asset-thumb-uploading" v-if="aud.uploading">

                <el-icon class="custom-spin"><Loading /></el-icon>

              </div>

            </div>

            <el-upload

              v-if="hasSeedanceAssetCapacity"

              :action="''"

              :auto-upload="false"

              :show-file-list="false"

              :on-change="onSeedanceReferenceFileChange"

              :accept="isWan3Platform ? 'image/jpeg,image/png,image/bmp,image/webp,video/mp4,video/quicktime,audio/wav,audio/mpeg' : 'image/*,video/*,audio/*'"

              multiple

              class="asset-add-btn asset-add-btn-reference"

              :disabled="workspaceDisabled || generating"

            >

              <div class="asset-add-inner" title="添加参考">

                <el-icon><Plus /></el-icon>

              </div>

            </el-upload>

            <button
              v-if="hasSeedanceAssets"
              type="button"
              class="asset-clear-inline"
              title="清空参考"
              @click.stop="clearAllSeedanceAssetReferences"
            >
              <el-icon><Close /></el-icon>
            </button>

          </div>

        </div>

      </div>

      <div class="settings-section" :class="{ 'settings-collapsed': settingsCollapsed, 'has-platform-warning': !platformAvailable || !!referenceValidationMessage }">

      <button
        type="button"
        class="settings-toggle-btn"
        :class="{ active: !settingsCollapsed }"
        :title="settingsCollapsed ? '展开设置' : '收起设置'"
        :aria-label="settingsCollapsed ? '展开设置' : '收起设置'"
        :aria-expanded="!settingsCollapsed"
        @click="toggleSettingsCollapsed"
      >
        <el-icon><Setting /></el-icon>
      </button>

      <div v-show="!settingsCollapsed" class="settings-summary">

        <div class="settings-tags">

          <el-popover
            v-if="displayPlatformOptions.length"
            placement="top"
            :width="'auto'"
            trigger="click"
            v-model:visible="platformPopoverVisible"
            :disabled="workspaceDisabled"
            popper-class="tag-options-popover platform-options-popover"
          >
            <template #reference>
              <span class="settings-tag clickable platform-setting-tag" :class="{ 'platform-disabled': platform && !platformAvailable }" :title="platformLabel" @click="openTagPopover('platform')">
                <img v-if="platformLogo" :src="platformLogo" class="platform-brand-logo" alt="" />
                <span class="settings-tag-text">{{ platformLabel }}</span>
                <span v-if="platform && !platformAvailable" class="platform-disabled-badge">已停用</span>
              </span>
            </template>
            <div class="tag-option-list platform-option-list">
              <div
                v-for="item in displayPlatformOptions"
                :key="item.value"
                class="tag-option-item platform-option-row"
                :class="{ active: selectedDisplayPlatform === item.value, 'platform-disabled': item.disabled, 'platform-preview-disabled': item.alwaysVisible && item.disabled }"
                :aria-disabled="item.disabled"
                @click="selectDisplayPlatform(item.value)"
              >
                <span class="platform-option-icon" :class="`platform-icon-${item.icon}`">
                  <img :src="item.logo" class="platform-brand-logo" alt="" />
                </span>
                <span class="platform-option-name">{{ item.label }}</span>
                <span v-if="item.disabled && !item.alwaysVisible" class="platform-disabled-badge">已停用</span>
              </div>
            </div>
          </el-popover>

          <el-popover
            placement="top"
            :width="'auto'"
            trigger="click"
            v-model:visible="sizePopoverVisible"
            :disabled="workspaceDisabled"
            popper-class="tag-options-popover"
          >
            <template #reference>
              <span
                class="settings-tag clickable"
                :class="resolutionToneClass(modelSize)"
                :title="sizeLabel"
                @click="openTagPopover('size')"
              ><span class="settings-tag-text">{{ sizeLabel }}</span></span>
            </template>
            <div class="tag-option-list resolution-option-list">
              <div
                v-for="opt in sizeOptions"
                :key="opt.value"
                class="tag-option-item resolution-option-card"
                :class="[{ active: modelSize === opt.value }, resolutionToneClass(opt.value)]"
                @click="selectOption('size', opt.value)"
              >
                <span class="resolution-option-preview" aria-hidden="true">
                  <span class="resolution-option-shape" :style="resolutionPreviewStyle(opt.value)"></span>
                </span>
                <span class="resolution-option-label">{{ opt.label.split('(')[0].trim() }}</span>
              </div>
            </div>
          </el-popover>

          <el-popover
            placement="top"
            :width="336"
            trigger="click"
            v-model:visible="durationPopoverVisible"
            :disabled="workspaceDisabled"
            popper-class="tag-options-popover duration-options-popover"
          >
            <template #reference>
              <span
                class="settings-tag clickable duration-setting-tag"
                :aria-label="`视频时长 ${modelSeconds} 秒`"
                :title="`${modelSeconds}秒`"
                @click="openTagPopover('duration')"
              >
                <span class="settings-tag-text">{{ modelSeconds }}秒</span>
              </span>
            </template>
            <div class="duration-setting-head">
              <div class="duration-setting-copy">
                <span class="duration-setting-title">视频时长</span>
              </div>
            </div>

            <div class="duration-control-row">
              <div v-if="!isDurationFixed" class="duration-ruler">
                <input
                  id="video-duration-slider"
                  v-model="durationSliderValue"
                  class="duration-range-input"
                  type="range"
                  :min="durationSliderMin"
                  :max="durationSliderMax"
                  :step="durationSliderStep"
                  :style="durationSliderStyle"
                  :disabled="generating"
                  :aria-label="`视频时长，当前 ${modelSeconds} 秒`"
                />
              </div>

              <div v-else class="duration-fixed-ruler" aria-hidden="true">
                <div class="duration-fixed-track"></div>
                <span class="duration-fixed-thumb"></span>
              </div>

              <div class="duration-value-wrap">
                <input
                  v-model="durationInputValue"
                  class="duration-value-pill duration-value-input"
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  maxlength="3"
                  :aria-label="`当前时长 ${modelSeconds} 秒`"
                  :disabled="generating"
                  @focus="beginDurationEdit"
                  @input="handleDurationInput"
                  @blur="commitDurationInput"
                  @keydown.enter.prevent="commitDurationInput"
                  @keydown.esc="cancelDurationInput"
                />
                <span class="duration-value-unit" aria-hidden="true">s</span>
              </div>
            </div>
          </el-popover>

        </div>

      </div>



      <el-button

        type="primary"

        :loading="generating"

        :disabled="generating || !platformAvailable || !currentWorkspaceId || hasUploadingAssets || !!referenceValidationMessage"

        @click="handleGenerate"

        class="generate-button"

      >

        {{ generating ? '生成中...' : '生成' }}

      </el-button>

      <span v-if="!platformAvailable" class="no-platform-text" role="status">{{ platform ? '当前模型已停用，请切换模型' : '暂无可用模型' }}</span>
      <span v-else-if="referenceValidationMessage" class="no-platform-text" role="status">{{ referenceValidationMessage }}</span>

      </div><!-- /.settings-section -->

    </div>

    <el-dialog

      v-model="showRemarkDialog"

      :show-close="false"

      width="480px"

      align-center

      append-to-body

      class="custom-remark-dialog"

    >

      <template #header>

        <div class="dialog-header-row">

          <div class="header-left">

            <div class="icon-box"><el-icon><EditPen /></el-icon></div>

            <span class="header-title">备注信息</span>

          </div>

          <div class="close-btn" @click="showRemarkDialog = false">

            <el-icon><Close /></el-icon>

          </div>

        </div>

      </template>

      <div class="dialog-content">

        <div class="input-wrapper">

          <el-input

            ref="remarkInputRef"

            v-model="tempRemark"

            type="textarea"

            :rows="5"

            :maxlength="200"

            placeholder="在此输入备注信息..."

            resize="none"

            class="custom-textarea"

          />

          <div class="input-footer">

            <span></span>

            <span>{{ tempRemark ? tempRemark.length : 0 }} / 200</span>

          </div>

        </div>

      </div>

      <template #footer>

        <div class="dialog-footer-row">

          <el-button class="cancel-btn" @click="showRemarkDialog = false">取消</el-button>

          <el-button type="primary" class="confirm-btn" @click="confirmRemark">

            保存

          </el-button>

        </div>

      </template>

    </el-dialog>

    <el-dialog
      v-model="uploadAsAssetDialogVisible"
      title="上传为资产"
      width="560px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="upload-as-asset-body">
        <div class="uaa-target-group">
          <span class="uaa-label">目标素材组</span>
          <el-select v-model="uploadAsAssetSelectedGroup" placeholder="请选择素材组" filterable style="flex:1">
            <el-option v-for="g in assetGroups" :key="g.groupId" :label="g.name" :value="g.groupId" />
          </el-select>
        </div>

        <div class="uaa-select-all">
          <el-checkbox
            :model-value="uploadAsAssetItems.length > 0 && uploadAsAssetItems.every(i => i.selected)"
            :indeterminate="uploadAsAssetItems.some(i => i.selected) && !uploadAsAssetItems.every(i => i.selected)"
            @change="val => uploadAsAssetItems.forEach(i => i.selected = val)"
          >全选</el-checkbox>
          <span class="uaa-count">已选 {{ uploadAsAssetItems.filter(i => i.selected).length }} / {{ uploadAsAssetItems.length }}</span>
        </div>

        <div class="uaa-item-list">
          <div v-for="(item, idx) in uploadAsAssetItems" :key="idx" class="uaa-item">
            <el-checkbox v-model="item.selected" class="uaa-item-check" />
            <div class="uaa-item-thumb">
              <ReferenceThumbnail v-if="item.type === 'image' && (item.url || item.localUrl)" :src="item.localUrl || item.url" />
              <el-icon v-else-if="item.type === 'video'" :size="20"><VideoCamera /></el-icon>
              <el-icon v-else :size="20"><Headset /></el-icon>
            </div>
            <input class="uaa-item-name-input" v-model="item.assetName" maxlength="12" :placeholder="item.name.replace(/\.[^.]+$/, '').slice(0, 12)" />
            <el-tag size="small" :type="item.type === 'image' ? '' : item.type === 'video' ? 'warning' : 'success'" class="uaa-type-tag">
              {{ item.type === 'image' ? '图片' : item.type === 'video' ? '视频' : '音频' }}
            </el-tag>
            <div v-if="item.type === 'image'" class="uaa-real-person">
              <el-switch v-model="item.isRealPerson" active-text="真人" inactive-text="非真人" size="small" />
            </div>
            <el-tag v-else size="small" type="info" effect="plain">非真人</el-tag>
          </div>
        </div>
      </div>

      <template #footer>
        <el-button @click="uploadAsAssetDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="uploadAsAssetSubmitting" :disabled="!uploadAsAssetSelectedGroup || !uploadAsAssetItems.some(i => i.selected)" @click="handleUploadAsAsset">
          {{ uploadAsAssetSubmitting ? '上传中...' : '上传' }}
        </el-button>
      </template>
    </el-dialog>

    </div><!-- /.generate-panel-content -->

  </div><!-- 关闭 prompt-input-container 的上层包裹或 inner div -->

  </div><!-- 关闭 generate-wrapper -->

</template>



<script>
import { referenceDisplayUrl } from '../model/referenceUrls'

import { computed, ref, watch, nextTick, onMounted, onActivated, onUnmounted, reactive } from 'vue'

import { ElMessage } from 'element-plus'

import {

  Loading, Plus, Close,

  CircleClose, Delete,

  EditPen, Headset, Picture, VideoPlay, VideoCamera, Upload, ZoomIn, WarningFilled, Setting,

  MagicStick, FolderOpened, Refresh

} from '@element-plus/icons-vue'



import { listAssetGroups, uploadAsset } from '@/api/volcAsset'
import ReferenceThumbnail from './ReferenceThumbnail.vue'
import AssetLibraryDialog from './AssetLibraryDialog.vue'
import { assetMediaType, assetSelectionKey, assetSelectionReason, assetLibraryReference, remapLibraryMentions, orderedLibraryItems } from '../model/assetLibrarySelection'
import { referenceThumbnailUrl, referenceHoverThumbnailUrl } from '../model/referenceThumbnails'
import { getOssImageCrossorigin } from '@/utils/ossImageCache'
import { useMentionWindow } from '../model/useMentionWindow'
import { useVolcMentionAssets } from '../model/useVolcMentionAssets'
import { hasPermission } from '@/api/auth'
import { notifyVolcAssetsChanged, onVolcAssetsChanged } from '@/utils/volcAssetEvents'
import wan3ReferencePolicy from '../model/wan3ReferencePolicy'
import h3VideoPolicy from '../model/h3VideoPolicy'
import bytedanceLogo from '@/assets/bytedance-color.svg'
import wanLogo from '@/assets/wan-color.png'
import h3Logo from '@/assets/runninghub-h3.svg'
import mentionAudioIcon from '@/assets/images/video-prompt/mention-audio.webp'
import mentionVideoIcon from '@/assets/images/video-prompt/mention-video.webp'



export default {

  name: 'GeneratePanel',

  components: {
    ReferenceThumbnail, AssetLibraryDialog,

    CircleClose, Loading, Plus, Close, Delete, EditPen, Headset, Picture, VideoPlay, VideoCamera, Upload, ZoomIn, WarningFilled, Setting,

    MagicStick, FolderOpened, Refresh

  },

  props: {

    prompt: { type: String, default: '' },

    remark: { type: String, default: '' },

    seconds: { type: String, default: '15' },

    size: { type: String, default: '720x1280' },

    model: { type: String, default: '' },

    platform: { type: String, default: '' },

    platformOptions: { type: Array, default: () => [] },

    platformAvailable: { type: Boolean, default: true },

    generating: { type: Boolean, default: false },

    inputReference: { type: String, default: '' },

    batchCount: { type: Number, default: 1 },

    currentWorkspaceId: { type: [String, Number], default: null },

    scriptId: { type: [String, Number], default: null },

    initialPanelWidth: { type: Number, default: 392 }

  },

  emits: [

    'update:prompt', 'update:remark', 'update:seconds', 'update:size', 'update:model', 'update:platform', 

    'update:batchCount', 'update:inputReference', 'image-change', 

    'show-image-preview', 'remove-image', 'input-focus', 'input-blur', 

    'generate', 'paste', 'prompt-input', 'panel-resize'

  ],

  setup(props, { emit }) {

    const workspaceDisabled = computed(() => !props.currentWorkspaceId)

    const isInputFocused = ref(false)

    const isExpandedMode = ref(false)

    const imageUploading = ref(false)
    const isDragOver = ref(false)
    const isPanelResizing = ref(false)
    const panelWidth = ref(props.initialPanelWidth)
    let panelResizeRaf = null

    const inputReferenceLocal = ref(props.inputReference || '')

    

    const editorRef = ref(null) 

    const innerWrapperRef = ref(null)

    const remarkInputRef = ref(null)

    

    const showRemarkDialog = ref(false)

    const tempRemark = ref('')

    const localRemark = ref(props.remark)

    

    const previewObjectUrl = ref('')
    const inputReferenceFile = ref(null)

    const isObjectUrlPreview = ref(false)



    // 多模态资源类平台（共用图/视/音资源栏、@引用、payload 附加等 Seedance 风格 UX）
    const SEEDANCE_LIKE = ['seedance', 'seedance-fast', 'wan3', 'wan3-cd', 'runninghub-h3']
    const isSeedancePlatform = computed(() => SEEDANCE_LIKE.includes(props.platform))
    const isWan3Platform = computed(() => wan3ReferencePolicy.isWanPlatform(props.platform))
    const isH3Platform = computed(() => h3VideoPolicy.isH3Platform(props.platform))
    const usesPublicReferenceUrls = computed(() => isWan3Platform.value || isH3Platform.value)
    const referenceLimits = computed(() => isH3Platform.value
      ? h3VideoPolicy.LIMITS
      : isWan3Platform.value ? wan3ReferencePolicy.WAN3_LIMITS : { images: 9, videos: 3, audios: 3 })
    const showSeedanceVideoReference = true



    const unusedSeedanceAssets = computed(() => {

      if (!isSeedancePlatform.value) return { images: [], videos: [], audios: [] }

      const text = modelPrompt.value || ''

      const images = []

      const videos = []

      const audios = []

      seedanceImages.value.forEach((_, idx) => {

        if (!text.includes(`@图片${idx + 1}`)) images.push(idx)

      })

      if (showSeedanceVideoReference) seedanceVideos.value.forEach((_, idx) => {

        if (!text.includes(`@视频${idx + 1}`)) videos.push(idx)

      })

      seedanceAudios.value.forEach((_, idx) => {

        if (!text.includes(`@音频${idx + 1}`)) audios.push(idx)

      })

      return { images, videos, audios }

    })



    const hasUnusedSeedanceAssets = computed(() => {

      const u = unusedSeedanceAssets.value

      return u.images.length > 0 || u.videos.length > 0 || u.audios.length > 0

    })



    const hasUploadingAssets = computed(() => {

      return seedanceImages.value.some(i => i.uploading || i.validating) ||

        (showSeedanceVideoReference && seedanceVideos.value.some(v => v.uploading || v.validating)) ||

        seedanceAudios.value.some(a => a.uploading || a.validating) ||

        imageUploading.value

    })

    const seedanceImages = ref([])   

    const seedanceVideos = ref([])   

    const seedanceAudios = ref([])   

    const referenceValidationMessage = computed(() => {
      const references = {
        images: seedanceImages.value,
        videos: showSeedanceVideoReference ? seedanceVideos.value : [],
        audios: seedanceAudios.value
      }
      return h3VideoPolicy.getReferenceError(props.platform, references)
        || wan3ReferencePolicy.getWanReferenceError(props.platform, references)
    })

    const settingsCollapsed = ref(true)

    const toggleSettingsCollapsed = () => {
      settingsCollapsed.value = !settingsCollapsed.value
      if (settingsCollapsed.value) {
        platformPopoverVisible.value = false
        sizePopoverVisible.value = false
        durationPopoverVisible.value = false
      }
    }

    const hasSeedanceAssets = computed(() => {
      return seedanceImages.value.length > 0 ||
        (showSeedanceVideoReference && seedanceVideos.value.length > 0) ||
        seedanceAudios.value.length > 0
    })

    const hasSeedanceAssetCapacity = computed(() => {
      const limits = referenceLimits.value
      return seedanceImages.value.length < limits.images ||
        (showSeedanceVideoReference && seedanceVideos.value.length < limits.videos) ||
        seedanceAudios.value.length < limits.audios
    })



    const assetGroups = ref([])
    const hasVolcAssetViewPermission = computed(() => hasPermission('volc_asset:view'))
    const { assets: volcAssets, load: loadVolcAssets, loading: volcAssetsLoading, error: volcAssetsError } = useVolcMentionAssets(
      () => props.scriptId, hasVolcAssetViewPermission
    )
    const hasVolcAssetUploadPermission = computed(() => hasPermission('volc_asset:upload'))
    const uploadAsAssetDialogVisible = ref(false)
    const uploadAsAssetSelectedGroup = ref(null)
    const uploadAsAssetItems = ref([])
    const uploadAsAssetSubmitting = ref(false)

    const nonAssetItems = computed(() => {
      const items = []
      seedanceImages.value.forEach((img, idx) => {
        if (!getSelectedVolcAssetId(img, 'Image') && !img.isVolcAsset && img.url && !img.uploading) {
          items.push({ type: 'image', idx, url: img.url, name: img.fileName || `图片${idx + 1}`, assetType: 'Image', localUrl: img.localUrl, duration: 0 })
        }
      })
      seedanceVideos.value.forEach((vid, idx) => {
        if (!getSelectedVolcAssetId(vid, 'Video') && !vid.isVolcAsset && vid.url && !vid.uploading) {
          items.push({ type: 'video', idx, url: vid.url, name: vid.fileName || `视频${idx + 1}`, assetType: 'Video', localUrl: vid.localUrl, duration: vid.duration || 0 })
        }
      })
      seedanceAudios.value.forEach((aud, idx) => {
        if (!getSelectedVolcAssetId(aud, 'Audio') && !aud.isVolcAsset && aud.url && !aud.uploading) {
          items.push({ type: 'audio', idx, url: aud.url, name: aud.fileName || `音频${idx + 1}`, assetType: 'Audio', localUrl: aud.localUrl, duration: aud.duration || 0 })
        }
      })
      return items
    })

    const loadAssetGroups = async () => {
      if (!hasVolcAssetViewPermission.value) return
      try {
        const res = await listAssetGroups()
        if (res.code === 200) {
          const allGroups = (res.data || []).filter(g => g.groupId)
          if (props.scriptId) {
            const scriptGroups = allGroups.filter(g => String(g.scriptId) === String(props.scriptId))
            assetGroups.value = scriptGroups.length > 0 ? scriptGroups : allGroups
          } else {
            assetGroups.value = allGroups
          }
        }
      } catch (e) { /* ignore */ }
    }

    const openUploadAsAssetDialog = async () => {
      if (!hasVolcAssetUploadPermission.value) return ElMessage.warning('没有上传资产权限')
      if (nonAssetItems.value.length === 0) return ElMessage.warning('没有可上传的非资产素材')
      await loadAssetGroups()
      uploadAsAssetItems.value = nonAssetItems.value.map(item => ({
        ...item,
        selected: true,
        isRealPerson: item.type === 'image',
        assetName: item.name.replace(/\.[^.]+$/, '').slice(0, 12)
      }))
      // 优先选择当前剧本关联的素材组
      if (props.scriptId && assetGroups.value.length > 0) {
        const match = assetGroups.value.find(g => String(g.scriptId) === String(props.scriptId))
        uploadAsAssetSelectedGroup.value = match ? match.groupId : assetGroups.value[0].groupId
      } else {
        uploadAsAssetSelectedGroup.value = assetGroups.value.length > 0 ? assetGroups.value[0].groupId : null
      }
      uploadAsAssetDialogVisible.value = true
    }

    const handleUploadAsAsset = async () => {
      if (!hasVolcAssetUploadPermission.value) return ElMessage.warning('没有上传资产权限')
      const selectedItems = uploadAsAssetItems.value.filter(i => i.selected)
      if (selectedItems.length === 0) return ElMessage.warning('请选择要上传的素材')
      if (!uploadAsAssetSelectedGroup.value) return ElMessage.warning('请选择目标素材组')
      uploadAsAssetSubmitting.value = true
      let successCount = 0
      const failedNames = []
      for (const item of selectedItems) {
        try {
          const res = await uploadAsset({
            groupId: uploadAsAssetSelectedGroup.value,
            imageUrl: item.url,
            assetName: item.assetName || item.name.replace(/\.[^.]+$/, '').slice(0, 12),
            assetType: item.assetType,
            isRealPerson: item.isRealPerson,
            durationMs: item.assetType !== 'Image' && item.duration ? Math.round(item.duration * 1000) : null
          })
          if (res.code === 200) successCount++
          else failedNames.push(item.name)
        } catch {
          failedNames.push(item.name)
        }
      }
      uploadAsAssetSubmitting.value = false
      if (successCount > 0) {
        ElMessage.success(failedNames.length > 0
          ? `上传完成：成功 ${successCount} 个，失败 ${failedNames.length} 个`
          : `已成功上传 ${successCount} 个素材至资产库`)
        uploadAsAssetDialogVisible.value = false
        notifyVolcAssetsChanged({ source: 'generate-panel-upload', scriptId: props.scriptId, groupId: uploadAsAssetSelectedGroup.value })
      } else {
        ElMessage.error('全部上传失败')
      }
    }



    const resolveVolcCoverUrl = (url) => {

      if (!url || !url.startsWith('asset://')) return url

      const assetId = url.replace('asset://', '')

      const found = volcAssets.value.find(a => a.assetId === assetId)

      return found ? found.coverUrl : ''

    }



    const getVolcAssetCover = (img) => {

      if (img.localUrl && !img.localUrl.startsWith('asset://')) return img.localUrl

      const assetId = img.volcAssetId || (img.url && img.url.startsWith('asset://') ? img.url.replace('asset://', '') : null)

      if (!assetId) return ''

      const found = volcAssets.value.find(a => a.assetId === assetId)

      return found ? found.coverUrl : ''

    }



    const ASSET_TYPE_BY_MEDIA = {
      image: 'Image',
      video: 'Video',
      audio: 'Audio'
    }

    const MEDIA_PREFIX = {
      image: '图片',
      video: '视频',
      audio: '音频'
    }

    const normalizeMentionType = (type, assetType = '') => {
      if (type === 'volc-asset') {
        return assetType === 'Video' ? 'video' : assetType === 'Audio' ? 'audio' : 'image'
      }
      return type || ''
    }

    const MEDIA_ID_PREFIX = {
      image: 'img',
      video: 'vid',
      audio: 'aud'
    }

    const getAssetIdFromUri = (url) => {
      return url && typeof url === 'string' && url.startsWith('asset://')
        ? url.replace('asset://', '')
        : ''
    }

    const compactAssetUrls = (...urls) => {
      return urls
        .filter(Boolean)
        .map(url => String(url).trim())
        .filter(url => url && url !== 'null' && url !== 'undefined' && !url.startsWith('blob:'))
    }

    const getPreviewableUrl = (...urls) => {
      return compactAssetUrls(...urls).find(url => !url.startsWith('asset://')) || ''
    }

    const findVolcAssetByReference = (item = {}, fallbackAssetType = '') => {
      const explicitId = item.volcAssetId || item.assetId || getAssetIdFromUri(item.assetUri || item.url)
      if (explicitId) {
        const byId = volcAssets.value.find(asset => String(asset.assetId) === String(explicitId))
        if (byId) return byId
      }

      const refUrls = compactAssetUrls(item.url, item.mediaUrl, item.coverUrl, item.localUrl, item.volcAssetCover)
      if (!refUrls.length) return null

      return volcAssets.value.find(asset => {
        if (fallbackAssetType && asset.assetType && asset.assetType !== fallbackAssetType) return false
        const assetUrls = compactAssetUrls(asset.assetUri, asset.mediaUrl, asset.coverUrl)
        return assetUrls.some(url => refUrls.includes(url))
      }) || null
    }

    const resolveSelectedVolcAssetMeta = (item = {}, fallbackAssetType = '') => {
      const found = findVolcAssetByReference(item, fallbackAssetType)
      const explicitId = item.volcAssetId || item.assetId || getAssetIdFromUri(item.assetUri || item.url)
      const hasAssetHint = Boolean(found || explicitId || item.isVolcAsset || item.volcAssetName)
      if (!hasAssetHint) return null

      const assetId = explicitId || found?.assetId || ''
      if (!assetId && !found && !item.isVolcAsset) return null

      const assetType = item.assetType || found?.assetType || fallbackAssetType || 'Image'
      return {
        assetId,
        tableId: found?.tableId,
        assetUri: item.assetUri || found?.assetUri || (assetId ? `asset://${assetId}` : ''),
        sourceUrl: item.sourceUrl || found?.sourceUrl || found?.mediaUrl || '',
        assetType,
        name: item.volcAssetName || item.name || found?.name || item.fileName || '',
        coverUrl: getPreviewableUrl(item.volcAssetCover, item.coverUrl, found?.coverUrl, assetType === 'Image' ? item.localUrl : '', assetType === 'Image' ? item.url : ''),
        mediaUrl: getPreviewableUrl(item.mediaUrl, found?.mediaUrl, item.url, item.localUrl),
        isRealPerson: item.isRealPerson !== undefined ? item.isRealPerson : (found ? found.isRealPerson : assetType === 'Image')
      }
    }

    const getSelectedVolcAssetId = (item, fallbackAssetType) => {
      return resolveSelectedVolcAssetMeta(item, fallbackAssetType)?.assetId || ''
    }

    // Wan 3.0 只能接收公网 URL。历史任务可能只保存了 asset:// URI，
    // 这里优先取已加载资产的 sourceUrl，保证回填后再次生成不会携带私域 URI。
    const getWanReferenceUrl = (item, fallbackAssetType) => {
      const rawUrl = String(item?.url || '').trim()
      if (!rawUrl.toLowerCase().startsWith('asset://')) return rawUrl
      const assetMeta = resolveSelectedVolcAssetMeta(item, fallbackAssetType)
      return String(assetMeta?.sourceUrl || item?.sourceUrl || '').trim() || rawUrl
    }

    const createSeedanceMentionItem = (item, idx, mediaType) => {
      const uuid = `${MEDIA_PREFIX[mediaType]}${idx + 1}`
      const assetType = ASSET_TYPE_BY_MEDIA[mediaType]
      const assetMeta = resolveSelectedVolcAssetMeta(item, assetType)
      const id = `seedance-${MEDIA_ID_PREFIX[mediaType]}-${idx}`

      if (assetMeta) {
        return {
          id,
          uuid,
          coverUrl: assetMeta.coverUrl || '',
          instructionValue: assetMeta.assetUri || '',
          status: 999,
          type: 'volc-asset',
          assetUri: assetMeta.assetUri,
          sourceUrl: assetMeta.sourceUrl,
          assetId: assetMeta.assetId,
          tableId: assetMeta.tableId,
          name: assetMeta.name || uuid,
          isRealPerson: assetMeta.isRealPerson,
          assetType: assetMeta.assetType,
          mediaUrl: assetMeta.mediaUrl,
          selectedReference: true
        }
      }

      return {
        id,
        uuid,
        coverUrl: mediaType === 'audio' ? '' : (item.localUrl || item.url || ''),
        mediaUrl: item.localUrl || item.url || '',
        url: item.url || item.localUrl || '',
        localUrl: item.localUrl || '',
        name: item.fileName || item.name || uuid,
        instructionValue: mediaType === 'audio' ? (item.fileName || '') : '',
        status: 999,
        type: mediaType
      }
    }

    const seedanceMentionItems = computed(() => {

      const items = []

      seedanceImages.value.forEach((img, idx) => {

        items.push(createSeedanceMentionItem(img, idx, 'image'))

      })

      if (showSeedanceVideoReference) seedanceVideos.value.forEach((vid, idx) => {

        items.push(createSeedanceMentionItem(vid, idx, 'video'))

      })

      seedanceAudios.value.forEach((aud, idx) => {

        items.push(createSeedanceMentionItem(aud, idx, 'audio'))

      })

      return items

    })



    const getMediaDuration = (raw, mediaType) => {

      return new Promise((resolve, reject) => {

        const el = document.createElement(mediaType)

        const objectUrl = URL.createObjectURL(raw)

        el.preload = 'metadata'

        el.src = objectUrl

        el.onloadedmetadata = () => {

          URL.revokeObjectURL(objectUrl)

          resolve(el.duration)

        }

        el.onerror = () => {

          URL.revokeObjectURL(objectUrl)

          reject(new Error('无法读取媒体信息'))

        }

      })

    }



    const onSeedanceFileChange = (file, type, { silent = false } = {}) => {

      if (workspaceDisabled.value) return false

      const raw = file.raw

      if (!raw) return false

      if (type === 'image') {

        const limits = referenceLimits.value
        if (seedanceImages.value.length >= limits.images) { if (!silent) ElMessage.warning(`最多上传${limits.images}张图片`); return false }

        if (isWan3Platform.value) {
          const validation = wan3ReferencePolicy.validateWanImage(raw)
          if (!validation.ok) { if (!silent) ElMessage.error(validation.message); return false }
        } else if (!raw.type.startsWith('image/')) { if (!silent) ElMessage.error('请上传图片文件'); return false }

        if (!isWan3Platform.value && raw.size > 15 * 1024 * 1024) { if (!silent) ElMessage.error('图片大小不能超过15MB'); return false }

        const objectUrl = URL.createObjectURL(raw)

        const entry = reactive({ url: '', localUrl: objectUrl, file: raw, uploading: false, role: 'reference', fileName: raw.name })

        seedanceImages.value = [...seedanceImages.value, entry]
          return true

      } else if (type === 'video') {

        const limits = referenceLimits.value
        if (seedanceVideos.value.length >= limits.videos) { if (!silent) ElMessage.warning(`最多上传${limits.videos}个视频`); return false }

        if (isWan3Platform.value) {
          const validation = wan3ReferencePolicy.validateWanTimedMedia(raw, 'video')
          if (!validation.ok) { if (!silent) ElMessage.error(validation.message); return false }
        } else if (!raw.type.startsWith('video/')) { if (!silent) ElMessage.error('请上传视频文件'); return false }

        if (raw.size > 50 * 1024 * 1024) { if (!silent) ElMessage.error('单个视频不能超过50MB'); return false }

        const objectUrl = URL.createObjectURL(raw)

        const entry = reactive({ url: '', localUrl: objectUrl, file: raw, uploading: false, fileName: raw.name, duration: 0, validating: !usesPublicReferenceUrls.value })

        seedanceVideos.value = [...seedanceVideos.value, entry]

        // Wan 3.0 validates reference duration from the remote URL. Do not block
        // upload when browser metadata is unavailable or differs from the source.
        if (usesPublicReferenceUrls.value) {
          return true
        }

        getMediaDuration(raw, 'video').then((dur) => {

          entry.duration = dur
          entry.validating = false

          const minDuration = isWan3Platform.value ? 1 : 2
          if (dur < minDuration || dur > 15) {

            ElMessage.error(`视频时长 ${dur.toFixed(1)}s 不在有效范围 [2, 15]s 内`)

            removeSeedanceVideo(seedanceVideos.value.indexOf(entry))

            return

          }

          const totalDur = seedanceVideos.value.reduce((s, v) => s + (v.duration || 0), 0)

          if (totalDur > 15) {

            ElMessage.error(`所有视频总时长 ${totalDur.toFixed(1)}s 超过 15s 限制`)

            removeSeedanceVideo(seedanceVideos.value.indexOf(entry))

            return

          }
        }).catch((err) => {

          ElMessage.error(err.message || '无法读取视频信息')

          removeSeedanceVideo(seedanceVideos.value.indexOf(entry))

        })

        return true

      } else if (type === 'audio') {

        const limits = referenceLimits.value
        if (seedanceAudios.value.length >= limits.audios) { if (!silent) ElMessage.warning(`最多上传${limits.audios}个音频`); return false }

        if (isWan3Platform.value) {
          const validation = wan3ReferencePolicy.validateWanTimedMedia(raw, 'audio')
          if (!validation.ok) { if (!silent) ElMessage.error(validation.message); return false }
        } else if (!raw.type.startsWith('audio/')) { if (!silent) ElMessage.error('请上传音频文件'); return false }

        if (raw.size > 15 * 1024 * 1024) { if (!silent) ElMessage.error('单个音频不能超过15MB'); return false }

        const entry = reactive({ url: '', file: raw, uploading: false, fileName: raw.name, duration: 0, validating: !usesPublicReferenceUrls.value })

        seedanceAudios.value = [...seedanceAudios.value, entry]

        // Wan 3.0 validates reference duration from the remote URL. Do not block
        // upload when browser metadata is unavailable or differs from the source.
        if (usesPublicReferenceUrls.value) {
          return true
        }

        getMediaDuration(raw, 'audio').then((dur) => {

          entry.duration = dur
          entry.validating = false

          const minDuration = isWan3Platform.value ? 1 : 2
          if (dur < minDuration || dur > 15) {

            ElMessage.error(`音频时长 ${dur.toFixed(1)}s 不在有效范围 [2, 15]s 内`)

            removeSeedanceAudio(seedanceAudios.value.indexOf(entry))

            return

          }

          const totalDur = seedanceAudios.value.reduce((s, a) => s + (a.duration || 0), 0)

          if (totalDur > 15) {

            ElMessage.error(`所有音频总时长 ${totalDur.toFixed(1)}s 超过 15s 限制`)

            removeSeedanceAudio(seedanceAudios.value.indexOf(entry))

            return

          }
        }).catch((err) => {

          ElMessage.error(err.message || '无法读取音频信息')

          removeSeedanceAudio(seedanceAudios.value.indexOf(entry))

        })

        return true

      }

      return false

    }

    const onSeedanceReferenceFileChange = (file) => {
      const raw = file.raw
      if (!raw) return false

      if (raw.type.startsWith('image/')) {
        return onSeedanceFileChange(file, 'image')
      }

      if (showSeedanceVideoReference && raw.type.startsWith('video/')) {
        return onSeedanceFileChange(file, 'video')
      }

      if (raw.type.startsWith('audio/')) {
        return onSeedanceFileChange(file, 'audio')
      }

      ElMessage.error('请上传图片、视频或音频文件')
      return false
    }



    const renumberSeedanceMentions = (text, assetType, removedIdx) => {

      const prefix = assetType === 'image' ? '图片' : assetType === 'video' ? '视频' : '音频'

      const removedNum = removedIdx + 1 

      const regex = new RegExp(`@${prefix}(\\d+)`, 'g')

      return text.replace(regex, (match, numStr) => {

        const num = parseInt(numStr)

        if (num === removedNum) return ''

        if (num > removedNum) return `@${prefix}${num - 1}`

        return match

      })

    }



    const removeSeedanceImage = (idx) => {

      const item = seedanceImages.value[idx]

      if (item?.localUrl) { try { URL.revokeObjectURL(item.localUrl) } catch (e) { /* ignore */ } }

      const currentText = editorRef.value ? getEditorText() : modelPrompt.value

      seedanceImages.value = seedanceImages.value.filter((_, i) => i !== idx)

      const newText = renumberSeedanceMentions(currentText, 'image', idx)

      if (editorRef.value && currentText !== newText) {

        editorRef.value.innerHTML = formatTextToHtml(newText)

      }

      isLocked.value = true

      emit('update:prompt', newText)

      nextTick(updateWrapperHeight)

    }

    const removeSeedanceVideo = (idx) => {

      const item = seedanceVideos.value[idx]

      if (item?.localUrl) { try { URL.revokeObjectURL(item.localUrl) } catch (e) { /* ignore */ } }

      const currentText = editorRef.value ? getEditorText() : modelPrompt.value

      seedanceVideos.value = seedanceVideos.value.filter((_, i) => i !== idx)

      const newText = renumberSeedanceMentions(currentText, 'video', idx)

      if (editorRef.value && currentText !== newText) {

        editorRef.value.innerHTML = formatTextToHtml(newText)

      }

      isLocked.value = true

      emit('update:prompt', newText)

      nextTick(updateWrapperHeight)

    }

    const removeSeedanceAudio = (idx) => {

      const currentText = editorRef.value ? getEditorText() : modelPrompt.value

      seedanceAudios.value = seedanceAudios.value.filter((_, i) => i !== idx)

      const newText = renumberSeedanceMentions(currentText, 'audio', idx)

      if (editorRef.value && currentText !== newText) {

        editorRef.value.innerHTML = formatTextToHtml(newText)

      }

      isLocked.value = true

      emit('update:prompt', newText)

      nextTick(updateWrapperHeight)

    }

    const clearSeedanceMentions = (text, assetType) => {
      const prefix = assetType === 'image' ? '图片' : assetType === 'video' ? '视频' : '音频'
      return text
        .replace(new RegExp(`@${prefix}\\d+`, 'g'), '')
        .replace(/[ \t]{2,}/g, ' ')
        .replace(/\n{3,}/g, '\n\n')
        .trim()
    }

    const clearSeedanceAssetType = (assetType) => {
      const currentText = editorRef.value ? getEditorText() : modelPrompt.value

      if (assetType === 'image') {
        seedanceImages.value.forEach(item => {
          if (item?.localUrl) { try { URL.revokeObjectURL(item.localUrl) } catch (e) { /* ignore */ } }
        })
        seedanceImages.value = []
      } else if (assetType === 'video') {
        seedanceVideos.value.forEach(item => {
          if (item?.localUrl) { try { URL.revokeObjectURL(item.localUrl) } catch (e) { /* ignore */ } }
        })
        seedanceVideos.value = []
      } else if (assetType === 'audio') {
        seedanceAudios.value = []
      }

      const newText = clearSeedanceMentions(currentText, assetType)
      if (editorRef.value && currentText !== newText) {
        editorRef.value.innerHTML = formatTextToHtml(newText)
      }

      isLocked.value = true
      emit('update:prompt', newText)
      nextTick(updateWrapperHeight)
    }



    const clearSeedanceAssets = () => {

      seedanceImages.value.forEach(item => {

        if (item.localUrl) { try { URL.revokeObjectURL(item.localUrl) } catch (e) { /* ignore */ } }

      })

      seedanceVideos.value.forEach(item => {

        if (item.localUrl) { try { URL.revokeObjectURL(item.localUrl) } catch (e) { /* ignore */ } }

      })

      seedanceImages.value = []

      seedanceVideos.value = []

      seedanceAudios.value = []

    }

    const clearAllSeedanceAssetReferences = () => {
      const currentText = editorRef.value ? getEditorText() : modelPrompt.value
      let newText = clearSeedanceMentions(currentText, 'image')
      newText = clearSeedanceMentions(newText, 'video')
      newText = clearSeedanceMentions(newText, 'audio')

      clearSeedanceAssets()

      if (editorRef.value && currentText !== newText) {
        editorRef.value.innerHTML = formatTextToHtml(newText)
      }

      isLocked.value = true
      emit('update:prompt', newText)
      nextTick(updateWrapperHeight)
    }



    watch(() => props.platform, (val, oldVal) => {
      if (!oldVal || val === oldVal) return

      if (val === 'seedance' || val === 'seedance-fast') {

        emit('update:seconds', '5')

        emit('update:size', '496x864')

        emit('update:batchCount', 1)

      } else if (wan3ReferencePolicy.isWanPlatform(val)) {

        emit('update:seconds', '5')

        emit('update:size', '496x864')

        emit('update:model', 'wan3.0-video')

        emit('update:batchCount', 1)

      } else if (h3VideoPolicy.isH3Platform(val)) {
        emit('update:seconds', h3VideoPolicy.DEFAULT_SECONDS)
        emit('update:size', h3VideoPolicy.DEFAULT_SIZE)
        emit('update:model', h3VideoPolicy.MODEL)
        emit('update:batchCount', 1)
      } else {

        emit('update:seconds', '10')

        emit('update:size', '1280x720')

        clearSeedanceAssets()

      }

    })



    watch(() => props.scriptId, () => {

      clearSeedanceAssets()

      loadAssetGroups()

      if (editorRef.value) editorRef.value.innerHTML = ''

      localRemark.value = ''

      tempRemark.value = ''

      inputReferenceLocal.value = ''

      emit('update:prompt', '')

      emit('update:remark', '')

      emit('update:inputReference', '')

      nextTick(updateWrapperHeight)

    })



    const isLocked = ref(false)



    const previewCover = reactive({

      name: '',

      show: false,

      url: '',

      type: '',

      source: '',

      style: { top: '0px', left: '0px' },


      loadError: false

    })

    const previewImageUrl = computed(() => referenceHoverThumbnailUrl(previewCover.url))
    const previewImageDimensions = ref(null)
    const previewDimensionCache = new Map()
    watch(previewImageUrl, url => {
      previewImageDimensions.value = previewDimensionCache.get(url) || null
    }, { flush: 'sync' })
    const previewImageSize = computed(() => {
      const dimensions = previewImageDimensions.value
      if (!dimensions) return { width: 240, height: 160 }
      const scale = Math.min(240 / dimensions.width, 300 / dimensions.height,
        Math.max(1, window.innerWidth - 20) / dimensions.width,
        Math.max(1, window.innerHeight - 64) / dimensions.height)
      return { width: Math.max(1, Math.round(dimensions.width * scale)), height: Math.max(1, Math.round(dimensions.height * scale)) }
    })
    const handlePreviewImageLoad = (event) => {
      const image = event.target
      if (image.getAttribute('src') !== previewImageUrl.value || !image.naturalWidth || !image.naturalHeight) return
      const dimensions = { width: image.naturalWidth, height: image.naturalHeight }
      previewDimensionCache.delete(previewImageUrl.value)
      previewDimensionCache.set(previewImageUrl.value, dimensions)
      if (previewDimensionCache.size > 128) previewDimensionCache.delete(previewDimensionCache.keys().next().value)
      previewImageDimensions.value = dimensions
      syncPreviewStyleToAnchor()
    }

    const previewCoverHovered = ref(false)
    const previewPointerInteracting = ref(false)
    const previewVideoRef = ref(null)
    const previewAudioRef = ref(null)

    let previewInteractTimer = null
    let previewAnchorEl = null
    let previewAnchorRect = null

    const resetMediaElement = (mediaEl) => {
      if (!mediaEl) return
      mediaEl.pause()
      try {
        mediaEl.currentTime = 0
      } catch (err) {
        // Some remote media streams do not allow seeking before metadata is ready.
      }
    }

    const stopPreviewMedia = () => {
      resetMediaElement(previewVideoRef.value)
      resetMediaElement(previewAudioRef.value)
    }

    watch(
      () => ({
        show: previewCover.show,
        type: previewCover.type,
        url: previewCover.url,
        loadError: previewCover.loadError
      }),
      () => stopPreviewMedia(),
      { flush: 'post' }
    )

    const getPreviewLoadErrorState = (url, type, source) => {
      return previewCover.url === url && previewCover.type === type && previewCover.source === source
        ? previewCover.loadError
        : false
    }

    const clampToViewport = (value, min, max) => {
      return Math.min(Math.max(value, min), Math.max(min, max))
    }

    const cloneDomRect = (rect) => {
      return {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.width,
        height: rect.height
      }
    }

    const setPreviewAnchor = (el) => {
      previewAnchorEl = el || null
      previewAnchorRect = el ? cloneDomRect(el.getBoundingClientRect()) : null
    }

    const refreshPreviewAnchorRect = () => {
      if (previewAnchorEl && previewAnchorEl.isConnected) {
        previewAnchorRect = cloneDomRect(previewAnchorEl.getBoundingClientRect())
      }

      return previewAnchorRect
    }

    const getPreviewSize = (type, override = {}) => {
      if (override.width && override.height) {
        return override
      }
      if (type === 'image') return previewImageSize.value

      const isAudio = type === 'audio'
      return {
        width: type === 'video' ? 320 : isAudio ? 300 : 240,
        height: type === 'video' ? 180 : isAudio ? 64 : 240
      }
    }

    const getPreviewUnavailableSize = (type) => {
      if (type === 'image') return { width: 120, height: 120 }
      const { width, height } = getPreviewSize(type)
      return {
        width: Math.round(width / 2),
        height: Math.round(height / 2)
      }
    }

    const getPreviewStyleAboveRect = (rect, type, sizeOverride = {}) => {
      const { width, height: mediaHeight } = getPreviewSize(type, sizeOverride)
      const height = mediaHeight + (previewCover.name ? 32 : 0) + 4
      const gap = 10
      const viewportPadding = 8
      const maxLeft = window.innerWidth - width - 4 - viewportPadding
      const maxTop = window.innerHeight - height - viewportPadding
      let top = rect.top - height - gap

      if (top < viewportPadding) {
        top = rect.bottom + gap
      }

      return {
        position: 'fixed',
        top: `${Math.round(clampToViewport(top, viewportPadding, maxTop))}px`,
        left: `${Math.round(clampToViewport(rect.left + (rect.width / 2) - ((width + 4) / 2), viewportPadding, maxLeft))}px`
      }
    }

    const getPreviewStyleBesideRect = (rect, type, sizeOverride = {}) => {
      const { width, height: mediaHeight } = getPreviewSize(type, sizeOverride)
      const height = mediaHeight + (previewCover.name ? 32 : 0) + 4
      const gap = 10
      const viewportPadding = 8
      const canPlaceRight = rect.right + gap + width + 4 <= window.innerWidth - viewportPadding
      const left = canPlaceRight
        ? rect.right + gap
        : Math.max(viewportPadding, rect.left - gap - width - 4)
      const top = clampToViewport(
        rect.top + rect.height / 2 - height / 2,
        viewportPadding,
        window.innerHeight - height - viewportPadding
      )

      return {
        position: 'fixed',
        top: `${Math.round(top)}px`,
        left: `${Math.round(left)}px`
      }
    }

    const syncPreviewStyleToAnchor = (sizeOverride = {}) => {
      if (!refreshPreviewAnchorRect()) return

      if (previewCover.source === 'mention-menu') {
        previewCover.style = getPreviewStyleBesideRect(previewAnchorRect, previewCover.type, sizeOverride)
        return
      }

      if (previewCover.source === 'asset-thumb') {
        previewCover.style = getPreviewStyleAboveRect(previewAnchorRect, previewCover.type, sizeOverride)
        return
      }

      previewCover.style = getPreviewStyleAboveRect(previewAnchorRect, previewCover.type, sizeOverride)
    }



    watch(() => props.remark, (val) => {

      localRemark.value = val

    })



    watch(() => props.prompt, (val) => {

      if (isLocked.value) {

        isLocked.value = false 

        return

      }

      if (editorRef.value && getEditorText() !== val) {

        editorRef.value.innerHTML = formatTextToHtml(val)

        updateWrapperHeight()

      }

    })



    let blurTimer = null

    const wrapperStyle = ref({})

    const promptContainerStyle = computed(() => {

      // expanded-layout 卡片下让 flex 决定高度，不再透传内嵌 wrapper 的固定 height
      return {}

    })



    const modelPrompt = computed(() => props.prompt)

    const previewUnavailableText = computed(() => {
      const labelMap = { video: '视频', audio: '音频', image: '图片' }
      return `${labelMap[previewCover.type] || '资源'}无法访问`
    })

    const modelSeconds = computed({ get: () => props.seconds, set: (val) => emit('update:seconds', val) })

    const modelSize = computed({ get: () => props.size, set: (val) => emit('update:size', val) })

    const modelPlatform = computed({ get: () => props.platform, set: (val) => emit('update:platform', val) })

    const modelBatchCount = computed({ get: () => props.batchCount, set: (val) => emit('update:batchCount', val) })



    const durationOptions = computed(() => {
      if (isWan3Platform.value || isH3Platform.value) {
        return Array.from({ length: 29 }, (_, i) => String(i + 2))
      }

      if (props.platform === 'seedance' || props.platform === 'seedance-fast') {

        return Array.from({ length: 12 }, (_, i) => String(i + 4))

      }

      return ['10', '15']

    })

    const durationOptionNumbers = computed(() => durationOptions.value
      .map(item => Number(item))
      .filter(item => Number.isFinite(item))
      .sort((a, b) => a - b))

    const durationSliderMin = computed(() => durationOptionNumbers.value[0] || 0)

    const durationSliderMax = computed(() => durationOptionNumbers.value[durationOptionNumbers.value.length - 1] || durationSliderMin.value)

    const durationSliderStep = computed(() => {
      const options = durationOptionNumbers.value
      if (options.length <= 1) return 1
      const diffs = options.slice(1).map((item, index) => item - options[index]).filter(item => item > 0)
      return Math.min(...diffs) || 1
    })

    const isDurationFixed = computed(() => durationOptionNumbers.value.length <= 1)

    const snapDurationValue = (value) => {
      const options = durationOptionNumbers.value
      if (!options.length) return durationSliderMin.value

      const numeric = Number.parseInt(String(value), 10)
      const bounded = Number.isFinite(numeric)
        ? Math.min(Math.max(numeric, durationSliderMin.value), durationSliderMax.value)
        : durationSliderMin.value

      return options.reduce(
        (closest, item) => Math.abs(item - bounded) < Math.abs(closest - bounded) ? item : closest,
        options[0]
      )
    }

    const durationInputValue = ref('')
    const durationInputEditing = ref(false)

    const beginDurationEdit = (event) => {
      durationInputEditing.value = true
      durationInputValue.value = String(durationSliderValue.value)
      nextTick(() => event?.target?.select?.())
    }

    const handleDurationInput = (event) => {
      const input = event.target
      const sanitized = String(input.value || '').replace(/\D/g, '').slice(0, 3)
      if (input.value !== sanitized) input.value = sanitized
      durationInputValue.value = sanitized
    }

    const commitDurationInput = () => {
      const rawValue = durationInputValue.value.trim()
      const snapped = rawValue ? snapDurationValue(rawValue) : durationSliderValue.value
      durationInputValue.value = String(snapped)
      durationInputEditing.value = false
      emit('update:seconds', String(snapped))
    }

    const cancelDurationInput = () => {
      durationInputValue.value = String(durationSliderValue.value)
      durationInputEditing.value = false
    }

    watch(() => props.seconds, (value) => {
      if (!durationInputEditing.value) durationInputValue.value = String(snapDurationValue(value))
    }, { immediate: true })

    const durationSliderValue = computed({
      get: () => {
        const current = Number(props.seconds)
        if (!Number.isFinite(current)) return durationSliderMin.value
        return Math.min(Math.max(current, durationSliderMin.value), durationSliderMax.value)
      },
      set: (val) => {
        const next = Number(val)
        if (!Number.isFinite(next)) return

        const snapped = snapDurationValue(next)

        emit('update:seconds', String(snapped))
      }
    })

    watch([durationSliderMin, durationSliderMax], () => {
      if (!durationInputEditing.value) durationInputValue.value = String(snapDurationValue(props.seconds))
    })

    const durationSliderProgress = computed(() => {
      const min = durationSliderMin.value
      const max = durationSliderMax.value
      if (max <= min) return 100

      const current = Math.min(Math.max(durationSliderValue.value, min), max)
      return ((current - min) / (max - min)) * 100
    })

    const durationSliderStyle = computed(() => ({
      '--duration-progress': `${durationSliderProgress.value}%`
    }))

    const durationTickItems = computed(() => {
      const min = durationSliderMin.value
      const max = durationSliderMax.value
      const span = max - min
      const thumbSize = 15
      const thumbHalf = thumbSize / 2

      return durationOptionNumbers.value.map(item => {
        const ratio = span > 0 ? (item - min) / span : 1
        const position = ratio * 100
        const thumbOffset = thumbHalf - (ratio * thumbSize)
        return {
          value: String(item),
          number: item,
          label: String(item),
          style: { left: `calc(${position}% + ${thumbOffset}px)` }
        }
      })
    })

    const sizeOptions = computed(() => {
      if (isH3Platform.value) return h3VideoPolicy.SIZES.map(value => ({ value, label: value }))

      if (isWan3Platform.value) {
        return [
          { value: '864x496', label: '480p 横屏 (864x496)' },
          { value: '496x864', label: '480p 竖屏 (496x864)' },
          { value: '1280x720', label: '720p 横屏 (1280x720)' },
          { value: '720x1280', label: '720p 竖屏 (720x1280)' }
          // { value: '1920x1080', label: '1080p 横屏 (1920x1080)' },
          // { value: '1080x1920', label: '1080p 竖屏 (1080x1920)' },
          // { value: '1440x1440', label: '1080p 方形 (1440x1440)' },
          // { value: '1664x1248', label: '1080p 4:3 (1664x1248)' },
          // { value: '1248x1664', label: '1080p 3:4 (1248x1664)' }
        ]
      }

      if (props.platform === 'seedance-fast') {
        // Fast 不支持 1080P
        return [
          { value: '864x496', label: '480p 横屏 (864x496)' },
          { value: '496x864', label: '480p 竖屏 (496x864)' },
          // { value: '1280x720', label: '720p 横屏 (1280x720)' },
          // { value: '720x1280', label: '720p 竖屏 (720x1280)' }
        ]
      }

      if (props.platform === 'seedance') {

        return [

          { value: '864x496', label: '480p 横屏 (864x496)' },
          { value: '496x864', label: '480p 竖屏 (496x864)' },
          // { value: '1280x720', label: '720p 横屏 (1280x720)' },
          // { value: '720x1280', label: '720p 竖屏 (720x1280)' },
          // { value: '1920x1080', label: '1080p 横屏 (1920x1080)' },
          // { value: '1080x1920', label: '1080p 竖屏 (1080x1920)' }

        ]

      }

      return [

        // { value: '1280x720', label: '720p 横屏 (1280x720)' },
        // { value: '720x1280', label: '720p 竖屏 (720x1280)' }

      ]

    })

    const formatPlatformLabel = (label) => String(label || '').replace(/（默认）|\(默认\)/g, '').trim()

    const sizeSegmentOptions = computed(() => sizeOptions.value.map(item => {
      const shortLabel = item.label.split('(')[0].trim()
      const parts = shortLabel.split(/\s+/)
      return {
        ...item,
        quality: parts[0] || shortLabel,
        orientation: parts[1] || ''
      }
    }))

    const activeSizeSegmentIndex = computed(() => {
      const index = sizeSegmentOptions.value.findIndex(item => item.value === modelSize.value)
      return index >= 0 ? index : 0
    })

    const sizeSegmentStyle = computed(() => ({
      '--segment-count': sizeSegmentOptions.value.length || 1
    }))

    const sizeSegmentIndicatorStyle = computed(() => {
      const count = sizeSegmentOptions.value.length || 1
      return {
        width: `calc((100% - 4px) / ${count})`,
        transform: `translateX(${activeSizeSegmentIndex.value * 100}%)`
      }
    })

    const modelSegmentOptions = computed(() => props.platformOptions.map(item => {
      const fullLabel = item.label || item.platformName || item.platformCode
      return {
        value: item.platformCode,
        label: formatPlatformLabel(fullLabel)
      }
    }))

    const activeModelSegmentIndex = computed(() => {
      const index = modelSegmentOptions.value.findIndex(item => item.value === modelPlatform.value)
      return index >= 0 ? index : 0
    })

    const modelSegmentStyle = computed(() => ({
      '--segment-count': modelSegmentOptions.value.length || 1
    }))

    const modelSegmentIndicatorStyle = computed(() => {
      const count = modelSegmentOptions.value.length || 1
      return {
        width: `calc((100% - 4px) / ${count})`,
        transform: `translateX(${activeModelSegmentIndex.value * 100}%)`
      }
    })



    const scheduleList = ref([]) 

    const showMentionMenu = ref(false)

    const mentionIndex = ref(0)

    const mentionKeyword = ref('')

    const mentionMenuStyle = ref({})

    const mentionMenuRef = ref(null)

    let mentionPreviewEnabled = true
    let mentionPreviewFromPointer = false
    let fullscreenOverlay = null
    let disposeFullscreenPreview = null

    const setMentionIndex = (index, { scroll = false } = {}) => {
      mentionPreviewEnabled = true
      mentionPreviewFromPointer = !scroll
      if (!filteredMentions.value.length) {
        mentionIndex.value = 0
        return
      }
      mentionIndex.value = Math.min(Math.max(index, 0), filteredMentions.value.length - 1)
      if (scroll) scrollToSelectedMention()
    }



    const forceReloadScheduleList = () => {

      try {

        const key = 'CHARACTER_LIST' 

        const stored = localStorage.getItem(key)

        if (!stored) {

          scheduleList.value = []

          return

        }

        const parsed = JSON.parse(stored)

        scheduleList.value = parsed

      } catch (e) {

        console.error('[Debug] Error parsing localStorage data:', e)

        scheduleList.value = []

      }

    }



    watch(scheduleList, () => {

      if (!isLocked.value && editorRef.value && modelPrompt.value) {

        const currentText = getEditorText()

        if (currentText === modelPrompt.value) {

          editorRef.value.innerHTML = formatTextToHtml(modelPrompt.value)

        }

      }

    })



    // 从 contenteditable 编辑器中提取文本，正确保留换行和 mention chip

    const getEditorText = (root = editorRef.value) => {

      if (!root) return ''

      const isBlock = node => node.nodeName === 'DIV' || node.nodeName === 'P'
      const walk = node => {
        if (node.nodeType === Node.TEXT_NODE) return node.textContent
        if (node.nodeType !== Node.ELEMENT_NODE) return ''
        if (node.classList.contains('mention-chip')) return getMentionChipText(node)
        // 浏览器在行尾或空行内放置的末尾 <br> 只是光标占位，不再追加换行。
        if (node.nodeName === 'BR') return node.nextSibling ? '\n' : ''

        let text = ''
        let previous = null
        for (const child of node.childNodes) {
          // 回车产生的块之间只计一次换行，连续空块仍保留用户输入的空行。
          if (previous && (isBlock(previous) || (isBlock(child) && !text.endsWith('\n')))) {
            text += '\n'
          }
          text += walk(child)
          previous = child
        }
        return text
      }

      return walk(root).replace(/\u200B/g, '').replace(/[\u00A0\u2009]/g, ' ')

    }



    const createMentionChip = (uuid, coverUrl = '', type = '') => {
      const chip = document.createElement('span')
      const token = `@${uuid}`
      chip.className = 'mention-chip'
      chip.contentEditable = 'false'
      chip.dataset.mentionText = token
      chip.setAttribute('aria-label', token)
      if (coverUrl) chip.dataset.coverUrl = coverUrl
      if (type) chip.dataset.mentionType = type

      const iconUrl = type === 'audio' ? mentionAudioIcon
        : type === 'video' ? mentionVideoIcon
          : type === 'image' ? referenceThumbnailUrl(coverUrl) : ''
      if (iconUrl) {
        const icon = document.createElement('img')
        icon.className = 'mention-chip-icon'
        icon.src = iconUrl
        icon.alt = ''
        icon.draggable = false
        icon.decoding = 'async'
        chip.appendChild(icon)
      } else if (type === 'image') {
        const placeholder = document.createElement('span')
        placeholder.className = 'mention-chip-icon mention-chip-image-placeholder'
        placeholder.setAttribute('aria-hidden', 'true')
        chip.appendChild(placeholder)
      }
      const label = document.createElement('span')
      label.className = 'mention-chip-label'
      label.textContent = MEDIA_PREFIX[type] ? uuid : token
      chip.appendChild(label)
      return chip
    }

    const handleEditorCopy = (event) => {
      const selection = window.getSelection()
      if (!event.clipboardData || !selection?.rangeCount || selection.isCollapsed) return false
      const range = selection.getRangeAt(0)
      if (!editorRef.value?.contains(range.commonAncestorContainer)) return false
      const fragment = range.cloneContents()
      const content = document.createElement('div')
      content.appendChild(fragment)
      event.clipboardData.setData('text/plain', getEditorText(content))
      event.preventDefault()
      return true
    }

    const handleEditorCut = (event) => {
      if (!handleEditorCopy(event)) return
      window.getSelection().getRangeAt(0).deleteContents()
      handleEditorInput(event)
    }

    const formatTextToHtml = (text) => {

      if (!text) return ''

      const escaped = document.createElement('div')
      escaped.textContent = text
      return escaped.innerHTML.replace(/(@[\u4e00-\u9fff\u3400-\u4dbfa-zA-Z0-9_-]+)([ \u00A0\u2009]?)/g, (fullMatch, match, separator) => {

        const uuid = match.substring(1)



        if (isSeedancePlatform.value) {

          const assetItem = seedanceMentionItems.value.find(i => i.uuid === uuid)

          if (assetItem && assetItem.status === 999) {

            const coverUrl = assetItem.coverUrl || ''
            const mentionType = normalizeMentionType(assetItem.type, assetItem.assetType)

            return `\u200B${createMentionChip(uuid, coverUrl, mentionType).outerHTML}\u200B${separator ? '\u2009' : ''}`

          }

          return fullMatch

        }



        const item = scheduleList.value.find(i => String(i.uuid) === String(uuid))

        if (item && item.status == 999) {

          const coverUrl = item.coverUrl || ''

          return `\u200B${createMentionChip(uuid, coverUrl, normalizeMentionType(item.type, item.assetType)).outerHTML}\u200B${separator ? '\u2009' : ''}`

        }

        return fullMatch

      })

    }



    const formattedModelPrompt = computed(() => {

      return formatTextToHtml(modelPrompt.value)

    })



    const availableMentions = computed(() => {

      if (isSeedancePlatform.value) {

        return orderedLibraryItems(
          volcAssets.value.filter(item => showSeedanceVideoReference || item.assetType !== 'Video'),
          seedanceMentionItems.value.filter(item => item.status === 999)
        )

      }

      return scheduleList.value.filter(item => item.status == 999)
    })

    const filteredMentions = computed(() => {
      const validItems = availableMentions.value

      if (!mentionKeyword.value) return validItems

      const k = mentionKeyword.value.toLowerCase()

      return validItems.filter(item => {

        const uuidMatch = item.uuid && String(item.uuid).toLowerCase().includes(k)

        const instrMatch = item.instructionValue && item.instructionValue.toLowerCase().includes(k)

        const nameMatch = item.name && String(item.name).toLowerCase().includes(k)
        return uuidMatch || instrMatch || nameMatch

      })

    })



    const assetLibraryVisible = ref(false)
    const assetLibraryLimits = referenceLimits
    const queuedLibraryItems = computed(() => [
      ...seedanceImages.value.map((entry, index) => ({ ...createSeedanceMentionItem(entry, index, 'image'), queueEntry: entry, inQueue: true })),
      ...seedanceVideos.value.map((entry, index) => ({ ...createSeedanceMentionItem(entry, index, 'video'), queueEntry: entry, inQueue: true })),
      ...seedanceAudios.value.map((entry, index) => ({ ...createSeedanceMentionItem(entry, index, 'audio'), queueEntry: entry, inQueue: true }))
    ].map((item, queueOrder) => ({ ...item, queueOrder })))
    const assetLibraryItems = computed(() => orderedLibraryItems(
      volcAssets.value.filter(item => showSeedanceVideoReference || item.assetType !== 'Video'), queuedLibraryItems.value
    ))
    const openAssetLibrary = () => {
      if (workspaceDisabled.value || props.generating || hasUploadingAssets.value || !isSeedancePlatform.value) return
      closeMentionMenu()
      hidePreview()
      // The page already loads and updates the shared @ list; opening is local only.
      assetLibraryVisible.value = true
    }
    const addLibraryReferences = (selection, { close = true, validate = true } = {}) => {
      if (validate && (workspaceDisabled.value || props.generating || hasUploadingAssets.value || !isSeedancePlatform.value)) return
      // Validate the entire batch against current data before mutating the queue.
      const candidates = new Map(assetLibraryItems.value.map(item => [assetSelectionKey(item), item]))
      const items = [...new Set(selection.map(assetSelectionKey))].map(key => candidates.get(key))
      for (const item of (validate ? items : [])) {
        const reason = !item ? '素材已更新，请重新选择' : assetSelectionReason(item, {
          selected: items.filter(Boolean), limits: assetLibraryLimits.value, isWan: usesPublicReferenceUrls.value
        })
        if (reason) { ElMessage.warning(reason); return }
      }
      const previous = queuedLibraryItems.value
      const text = editorRef.value ? getEditorText() : modelPrompt.value
      const nextText = remapLibraryMentions(text, previous, items)
      const references = items.map(item => ({ type: assetMediaType(item), entry: assetLibraryReference(item, usesPublicReferenceUrls.value) }))
      const retained = new Set(references.map(({ entry }) => entry.localUrl).filter(Boolean))
      for (const item of previous) {
        const url = item.queueEntry.localUrl
        if (url?.startsWith('blob:') && !retained.has(url)) URL.revokeObjectURL(url)
      }
      seedanceImages.value = references.filter(item => item.type === 'image').map(item => item.entry)
      seedanceVideos.value = references.filter(item => item.type === 'video').map(item => item.entry)
      seedanceAudios.value = references.filter(item => item.type === 'audio').map(item => item.entry)
      if (editorRef.value) editorRef.value.innerHTML = formatTextToHtml(nextText)
      if (nextText !== text) { isLocked.value = true; emit('update:prompt', nextText) }
      if (close) assetLibraryVisible.value = false
      closeMentionMenu()
      nextTick(updateAssetScrollHints)
      nextTick(updateWrapperHeight)
    }
    const onLibraryAssetDeleted = (item) => {
      const key = assetSelectionKey(item)
      const current = queuedLibraryItems.value
      if (current.some(entry => assetSelectionKey(entry) === key)) {
        addLibraryReferences(current.filter(entry => assetSelectionKey(entry) !== key), { close: false, validate: false })
      }
      volcAssets.value = volcAssets.value.filter(entry => assetSelectionKey(entry) !== key)
      notifyVolcAssetsChanged({ source: 'video-library-delete', scriptId: props.scriptId })
    }
    watch([() => props.scriptId, () => props.currentWorkspaceId, () => props.platform], () => { assetLibraryVisible.value = false })

    // A caret after text can belong to the parent element after blur/refocus.
    // Resolve that equivalent text position for both suggestions and insertion.
    const getMentionCursorRange = () => {
      const editor = editorRef.value
      const selection = window.getSelection()
      if (!editor || document.activeElement !== editor || !selection?.rangeCount) return null

      const range = selection.getRangeAt(0).cloneRange()
      if (!range.collapsed || !editor.contains(range.startContainer)) return null

      let node = range.startContainer
      if (node.nodeType === Node.ELEMENT_NODE) {
        node = node.childNodes[range.startOffset - 1]
        while (node?.nodeType === Node.ELEMENT_NODE) {
          if (node.matches('.mention-chip, [contenteditable="false"], br')) return null
          node = node.lastChild
        }
        if (node?.nodeType !== Node.TEXT_NODE) return null
        range.setStart(node, node.textContent.length)
        range.collapse(true)
      }

      if (node.nodeType !== Node.TEXT_NODE || node.parentElement?.closest('.mention-chip, [contenteditable="false"]')) return null
      return range
    }

    const checkMentionAtCursor = () => {
      if (fullscreenOverlay) return

      const range = getMentionCursorRange()

      if (!range) {

        showMentionMenu.value = false

        mentionMenuStyle.value = {}

        return

      }

      const node = range.startContainer

      if (node.nodeType === Node.TEXT_NODE) {

        const textBeforeCursor = node.textContent.slice(0, range.startOffset)

        const match = textBeforeCursor.match(/@([^@\s]*)$/)

        if (match) {

          if (isSeedancePlatform.value) {

            loadVolcAssets()

          } else {

            forceReloadScheduleList()

          }

          showMentionMenu.value = true

          mentionKeyword.value = match[1]

          mentionIndex.value = 0

          updateMentionMenuPosition()

        } else {

          showMentionMenu.value = false

          mentionKeyword.value = ''

          mentionMenuStyle.value = {}

        }

      } else {

        showMentionMenu.value = false

        mentionMenuStyle.value = {}

      }

    }



    const handleEditorInput = (e) => {

      isLocked.value = true

      const selection = window.getSelection()

      if (!selection.rangeCount) return

      const text = getEditorText()

      emit('update:prompt', text)

      emit('prompt-input', e)

      updateWrapperHeight()

      checkMentionAtCursor()

    }



    const closeMentionMenu = () => {
      mentionPreviewEnabled = false

      showMentionMenu.value = false

      mentionIndex.value = 0

      mentionMenuStyle.value = {}

      hidePreview()

    }



    // === 核心计算：基于视口的安全 Fixed 定位 ===

    const updateMentionMenuPosition = () => {

      const editor = editorRef.value

      if (!editor) return



      const selection = window.getSelection()

      if (!selection.rangeCount) return



      const range = selection.getRangeAt(0).cloneRange()

      range.collapse(true)

      

      const rects = range.getClientRects()

      let cursorRect = rects.length > 0 ? rects[0] : range.getBoundingClientRect()



      // 降级保护：如果浏览器返回的坐标为 0 (如正在连续删除或输入特殊字符)

      // 使用编辑器的边界位置作为兜底，确保菜单仍在输入框周围

      if (!cursorRect || (cursorRect.top === 0 && cursorRect.left === 0 && cursorRect.right === 0)) {

        const editorRect = editor.getBoundingClientRect()

        cursorRect = {

          top: editorRect.top,

          left: editorRect.left + 16

        }

      }



      const edge = 8, gap = 8, width = 240
      const cursorBottom = cursorRect.bottom || cursorRect.top + 24
      const above = cursorRect.top - gap - edge
      const below = window.innerHeight - cursorBottom - gap - edge
      const placeAbove = above >= 220 || above >= below
      const maxHeight = Math.min(220, Math.max(96, placeAbove ? above : below))
      const height = Math.min(maxHeight, Math.max(1, filteredMentions.value.length) * 46 + 50)
      const top = placeAbove ? cursorRect.top - gap - height : cursorBottom + gap
      mentionMenuStyle.value = {
        position: 'fixed',
        top: `${clampToViewport(top, edge, window.innerHeight - height - edge)}px`,
        left: `${clampToViewport(cursorRect.left, edge, window.innerWidth - width - edge)}px`,
        maxHeight: `${maxHeight}px`,
        zIndex: 999999
      }

    }



    const selectMention = (item, { insertPrompt = true } = {}) => {

      const addChip = chip => { if (insertPrompt) insertChipToEditor(chip) }
      isLocked.value = insertPrompt

      if (item.selectedReference) {
        const chipItem = {
          ...item,
          type: item.assetType === 'Video' ? 'video' : item.assetType === 'Audio' ? 'audio' : 'image'
        }
        addChip(chipItem)
        return
      }

      if (item.type === 'volc-asset') {
        if (usesPublicReferenceUrls.value) {
          const sourceUrl = String(item.sourceUrl || '').trim()
          if (!/^https?:\/\//i.test(sourceUrl)) {
            ElMessage.error('该素材缺少可下载的公开地址（source_url），无法用于当前模型')
            isLocked.value = false
            closeMentionMenu()
            return
          }
          const assetType = item.assetType || 'Image'
          const limits = referenceLimits.value
          if (assetType === 'Video') {
            if (seedanceVideos.value.length >= limits.videos) {
              ElMessage.warning(`最多上传${limits.videos}个视频`)
              isLocked.value = false
              closeMentionMenu()
              return
            }
            const index = seedanceVideos.value.length
            seedanceVideos.value = [...seedanceVideos.value, {
              url: sourceUrl,
              localUrl: sourceUrl,
              uploading: false,
              fileName: item.name || `视频${index + 1}`,
              duration: Number(item.duration) || (Number(item.durationMs) > 0 ? Number(item.durationMs) / 1000 : 0),
              volcAssetId: item.assetId
            }]
            addChip({ ...item, uuid: `视频${index + 1}`, type: 'video', coverUrl: sourceUrl, sourceUrl })
          } else if (assetType === 'Audio') {
            if (seedanceAudios.value.length >= limits.audios) {
              ElMessage.warning(`最多上传${limits.audios}个音频`)
              isLocked.value = false
              closeMentionMenu()
              return
            }
            const index = seedanceAudios.value.length
            seedanceAudios.value = [...seedanceAudios.value, {
              url: sourceUrl,
              uploading: false,
              fileName: item.name || `音频${index + 1}`,
              duration: Number(item.duration) || (Number(item.durationMs) > 0 ? Number(item.durationMs) / 1000 : 0),
              volcAssetId: item.assetId
            }]
            addChip({ ...item, uuid: `音频${index + 1}`, type: 'audio', sourceUrl })
          } else {
            if (seedanceImages.value.length >= limits.images) {
              ElMessage.warning(`最多上传${limits.images}张图片`)
              isLocked.value = false
              closeMentionMenu()
              return
            }
            const index = seedanceImages.value.length
            seedanceImages.value = [...seedanceImages.value, {
              url: sourceUrl,
              localUrl: sourceUrl,
              uploading: false,
              role: 'reference_image',
              fileName: item.name || `图片${index + 1}`,
              volcAssetId: item.assetId
            }]
            addChip({ ...item, uuid: `图片${index + 1}`, type: 'image', coverUrl: sourceUrl, sourceUrl })
          }
          closeMentionMenu()
          return
        }
        if (!showSeedanceVideoReference && item.assetType === 'Video') {
          ElMessage.info('视频参考暂未展示')
          isLocked.value = false
          closeMentionMenu()
          return
        }

        if (item.isRealPerson && (!item.assetType || item.assetType === 'Image')) {
          // 真人素材: 走火山引擎 asset:// 流程
          const alreadyAdded = seedanceImages.value.some(i => i.isVolcAsset && i.volcAssetId === item.assetId)

          if (!alreadyAdded) {

            if (seedanceImages.value.length >= 9) {

              ElMessage.warning('最多上传9张图片')

              isLocked.value = false

              closeMentionMenu()

              return

            }

            const imgIdx = seedanceImages.value.length

            const chipName = `图片${imgIdx + 1}`

            seedanceImages.value.push({

              url: item.assetUri,

              localUrl: item.coverUrl || '',

              volcAssetCover: item.coverUrl || '',

              uploading: false,

              role: 'reference',

              fileName: item.name || item.assetId,

              isVolcAsset: true,

              volcAssetId: item.assetId,

              volcAssetName: item.name || ''

            })

            const chipItem = { ...item, uuid: chipName, type: 'image' }

            addChip(chipItem)

          } else {

            const existingIdx = seedanceImages.value.findIndex(i => i.isVolcAsset && i.volcAssetId === item.assetId)

            const chipName = `图片${existingIdx + 1}`

            const chipItem = { ...item, uuid: chipName, type: 'image' }

            addChip(chipItem)

          }
        } else {
          // 非真人素材: 按 assetType 分流
          const assetType = item.assetType || 'Image'

          if (assetType === 'Video') {
            // 视频: 推入 seedanceVideos，chip 类型为 video
            const alreadyAdded = seedanceVideos.value.some(v => v.volcAssetId === item.assetId)

            if (!alreadyAdded) {

              if (seedanceVideos.value.length >= 3) {

                ElMessage.warning('最多上传3个视频')

                isLocked.value = false

                closeMentionMenu()

                return

              }

              seedanceVideos.value = [...seedanceVideos.value, {

                url: item.sourceUrl || item.mediaUrl,

                localUrl: '',

                uploading: false,

                fileName: item.name || item.assetId,

                duration: 0,

                volcAssetId: item.assetId,

                volcAssetName: item.name || ''

              }]

              const vidIdx = seedanceVideos.value.length

              const chipItem = { ...item, uuid: `视频${vidIdx}`, type: 'video', coverUrl: item.mediaUrl || item.coverUrl }

              addChip(chipItem)

            } else {

              const existingIdx = seedanceVideos.value.findIndex(v => v.volcAssetId === item.assetId)

              const chipItem = { ...item, uuid: `视频${existingIdx + 1}`, type: 'video', coverUrl: item.mediaUrl || item.coverUrl }

              addChip(chipItem)

            }
          } else if (assetType === 'Audio') {
            // 音频: 推入 seedanceAudios，chip 类型为 audio
            const alreadyAdded = seedanceAudios.value.some(a => a.volcAssetId === item.assetId)

            if (!alreadyAdded) {

              if (seedanceAudios.value.length >= 3) {

                ElMessage.warning('最多上传3个音频')

                isLocked.value = false

                closeMentionMenu()

                return

              }

              seedanceAudios.value = [...seedanceAudios.value, {

                url: item.sourceUrl || item.mediaUrl,

                uploading: false,

                fileName: item.name || item.assetId,

                duration: 0,

                volcAssetId: item.assetId,

                volcAssetName: item.name || ''

              }]

              const audIdx = seedanceAudios.value.length

              const chipItem = { ...item, uuid: `音频${audIdx}`, type: 'audio' }

              addChip(chipItem)

            } else {

              const existingIdx = seedanceAudios.value.findIndex(a => a.volcAssetId === item.assetId)

              const chipItem = { ...item, uuid: `音频${existingIdx + 1}`, type: 'audio' }

              addChip(chipItem)

            }
          } else {
            // 非真人图片: 直接用 sourceUrl，和普通图片一样
            const alreadyAdded = seedanceImages.value.some(i => i.volcAssetId === item.assetId)

            if (!alreadyAdded) {

              if (seedanceImages.value.length >= 9) {

                ElMessage.warning('最多上传9张图片')

                isLocked.value = false

                closeMentionMenu()

                return

              }

              const imgIdx = seedanceImages.value.length

              const chipName = `图片${imgIdx + 1}`

              seedanceImages.value.push({

                url: item.sourceUrl || item.mediaUrl,

                localUrl: item.sourceUrl || item.mediaUrl || '',

                uploading: false,

                role: 'reference',

                fileName: item.name || item.assetId,

                volcAssetId: item.assetId,

                volcAssetName: item.name || ''

              })

              const chipItem = { ...item, uuid: chipName, type: 'image' }

              addChip(chipItem)

            } else {

              const existingIdx = seedanceImages.value.findIndex(i => i.volcAssetId === item.assetId)

              const chipName = `图片${existingIdx + 1}`

              const chipItem = { ...item, uuid: chipName, type: 'image' }

              addChip(chipItem)

            }
          }
        }

        return

      }

      addChip(item)

    }



    const insertChipToEditor = (item) => {

      const selection = window.getSelection()

      const range = getMentionCursorRange()

      if (!range) return

      const node = range.startContainer

      

      if (node.nodeType === Node.TEXT_NODE) {

        const text = node.textContent

        const offset = range.startOffset

        const lastAtIndex = text.lastIndexOf('@', offset - 1)

        

        if (lastAtIndex !== -1) {

          range.setStart(node, lastAtIndex)

          range.setEnd(node, offset)

          range.deleteContents()



          const chip = createMentionChip(item.uuid, item.coverUrl, normalizeMentionType(item.type, item.assetType))



          const zeroSpaceBefore = document.createTextNode('\u200B')

          const spaceAfter = document.createTextNode('\u2009')

          const assetNameNode = item.name ? document.createTextNode(item.name) : null



          const fragment = document.createDocumentFragment()

          fragment.appendChild(zeroSpaceBefore)

          fragment.appendChild(chip)

          fragment.appendChild(spaceAfter)

          if (assetNameNode) fragment.appendChild(assetNameNode)



          range.insertNode(fragment)



          const cursorTarget = assetNameNode || spaceAfter

          range.setStartAfter(cursorTarget)

          range.setEndAfter(cursorTarget)

          selection.removeAllRanges()

          selection.addRange(range)



          isLocked.value = true

          emit('update:prompt', getEditorText())

          closeMentionMenu()

          updateWrapperHeight()

        }

      }

    }



    const getMentionChipTarget = (e) => {

      const target = e?.target

      if (!target || target.nodeType !== Node.ELEMENT_NODE) return null

      const chip = target.closest('.mention-chip')

      if (!chip) return null

      const container = e.currentTarget

      if (container && container.nodeType === Node.ELEMENT_NODE && !container.contains(chip)) return null

      return chip

    }

    const getMentionChipText = (chip) => {

      return (chip?.dataset.mentionText || chip?.innerText || chip?.textContent || '').replace(/\u200B/g, '').replace(/\u00A0/g, ' ').trim()

    }

    const isPointerOnMentionChip = (chip, e) => {

      if (!chip || !e || typeof e.clientX !== 'number' || typeof e.clientY !== 'number') return false

      const rects = Array.from(chip.getClientRects()).filter(rect => rect.width > 0 && rect.height > 0)
      const isInsideChipRect = rects.some(rect =>
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom
      )

      if (!isInsideChipRect) return false

      const elementsAtPoint = document.elementsFromPoint ? document.elementsFromPoint(e.clientX, e.clientY) : []
      if (!elementsAtPoint.length) return true

      const topMeaningfulElement = elementsAtPoint.find(el => !el.closest?.('.mention-media-preview'))
      if (!topMeaningfulElement) return false

      const hitChip = topMeaningfulElement.closest?.('.mention-chip')
      return hitChip === chip

    }

    const getSeedanceMentionIndex = (chip, type) => {

      const prefix = MEDIA_PREFIX[type]
      if (!prefix) return null

      const text = getMentionChipText(chip)
      const match = text.match(new RegExp(`^@${prefix}(\\d+)$`))
      if (!match) return null

      const index = Number(match[1]) - 1
      return Number.isInteger(index) && index >= 0 ? index : null

    }



    const getPreviewReferenceName = (item, fallback = '') => {
      return String(item?.volcAssetName || item?.name || item?.fileName || fallback).trim()
    }

    const handleHover = (e) => {
      if (fullscreenOverlay) return

      const target = getMentionChipTarget(e)

      if (!target) {

        if (previewCover.source === 'chip') hidePreview()

        return

      }

      if (target) {

        if (!isPointerOnMentionChip(target, e)) {

          if (previewCover.source === 'chip') hidePreview()
          return

        }


        const type = normalizeMentionType(target.getAttribute('data-mention-type') || '')

        let url = ''
        let name = getMentionChipText(target).replace(/^@/, '')

        if (isSeedancePlatform.value && MEDIA_PREFIX[type]) {

          const index = getSeedanceMentionIndex(target, type)
          if (index === null) {

            if (previewCover.source === 'chip') hidePreview()
            return

          }

          if (type === 'image') {

            const img = seedanceImages.value[index]

            if (img) {
              name = getPreviewReferenceName(img, name)

              const rawUrl = img.localUrl || getPreviewableUrl(img.sourceUrl, img.url, img.volcAssetCover)

              url = resolveVolcCoverUrl(rawUrl) || rawUrl

            }

          } else if (type === 'video') {

            const vid = seedanceVideos.value[index]

            if (vid) {
              url = vid.url || vid.localUrl || ''
              name = getPreviewReferenceName(vid, name)
            }

          } else if (type === 'audio') {

            const aud = seedanceAudios.value[index]

            if (aud) {
              url = aud.url || ''
              name = getPreviewReferenceName(aud, name)
            }

          }

        } else {

          url = target.getAttribute('data-cover-url') || ''
          name = getPreviewReferenceName(scheduleList.value.find(item => String(item.uuid) === name), name)

        }



        if (url && url !== 'null' && url !== 'undefined' && url.length > 0 && !url.startsWith('asset://')) {

          // Moving between the icon and label must not reset a loaded preview.
          if (previewCover.show && previewAnchorEl === target && previewCover.source === 'chip' && previewCover.url === url && previewCover.type === type) return

          const loadError = getPreviewLoadErrorState(url, type, 'chip')
          setPreviewAnchor(target)

          previewCover.url = url

          previewCover.type = type

          previewCover.source = 'chip'
          previewCover.name = name

          previewCover.loadError = loadError

          previewCover.show = true



          syncPreviewStyleToAnchor(loadError ? getPreviewUnavailableSize(type) : {})

        }

      }

    }



    const hidePreview = () => {

      stopPreviewMedia()

      previewCoverHovered.value = false
      previewPointerInteracting.value = false
      if (previewInteractTimer) { clearTimeout(previewInteractTimer); previewInteractTimer = null }

      previewCover.show = false

      previewCover.source = ''
      previewAnchorEl = null
      previewAnchorRect = null

    }



    const handleHoverOut = (e) => {

      const chip = getMentionChipTarget(e)
      if (chip && !chip.contains(e.relatedTarget) && !e.relatedTarget?.closest?.('.mention-media-preview')) {

        hidePreview()

      }

    }

    const getMentionItemPreviewMedia = (item) => {
      if (!item) return { url: '', type: '' }

      const itemType = item.type === 'volc-asset'
        ? (item.assetType === 'Video' ? 'video' : item.assetType === 'Audio' ? 'audio' : 'image')
        : item.type

      let url = ''
      if (itemType === 'audio') {
        url = getPreviewableUrl(item.mediaUrl, item.url, item.localUrl, item.coverUrl)
      } else {
        url = itemType === 'image'
          ? item.localUrl || getPreviewableUrl(item.sourceUrl, item.mediaUrl, item.url, item.coverUrl)
          : getPreviewableUrl(item.coverUrl, item.mediaUrl, item.localUrl, item.url)
      }

      url = resolveVolcCoverUrl(url) || url
      return { url, type: itemType }
    }

    const { rows: visibleMentionRows, top: mentionWindowTop, bottom: mentionWindowBottom, onScroll: onMentionScroll, scrollToSelected: scrollToSelectedMention } =
      useMentionWindow(filteredMentions, mentionIndex, showMentionMenu, mentionMenuRef)

    const onMentionMouseEnter = (index) => {
      setMentionIndex(index)
      // Re-entering the selected row does not change mentionIndex or run its watcher.
      nextTick(showSelectedMentionPreview)
    }

    const onMentionMouseLeave = (event) => {
      if (event.relatedTarget?.closest?.('.mention-media-preview.mention-menu')) return
      mentionPreviewEnabled = false
      if (previewCover.source === 'mention-menu') hidePreview()
    }

    const onMentionListScroll = (event) => {
      onMentionScroll(event)
      // Virtual scrolling can remove the anchor without firing mouseleave.
      if (mentionPreviewFromPointer) onMentionMouseLeave(event)
    }

    const showSelectedMentionPreview = () => {
      if (fullscreenOverlay || !mentionPreviewEnabled) return
      if (!showMentionMenu.value || filteredMentions.value.length === 0) {
        hidePreview()
        return
      }

      const item = filteredMentions.value[mentionIndex.value]
      const { url, type } = getMentionItemPreviewMedia(item)
      if (!url || url === 'null' || url === 'undefined' || url.startsWith('asset://')) {
        hidePreview()
        return
      }

      const activeItem = document.querySelector('.mention-list-popover .mention-item.active')
      if (!activeItem) return

      const loadError = getPreviewLoadErrorState(url, type, 'mention-menu')
      setPreviewAnchor(activeItem)

      previewCover.url = url
      previewCover.type = type
      previewCover.source = 'mention-menu'
      previewCover.name = getPreviewReferenceName(item, item.uuid || MEDIA_PREFIX[type])
      previewCover.loadError = loadError
      previewCover.show = true
      syncPreviewStyleToAnchor(loadError ? getPreviewUnavailableSize(type) : {})
    }

    watch(
      [showMentionMenu, mentionIndex, filteredMentions],
      ([opened], previous) => {
        if (opened && !previous[0]) {
          mentionPreviewEnabled = true
          mentionPreviewFromPointer = false
        }
        if (!opened) {
          mentionPreviewEnabled = false
          if (previewCover.source === 'mention-menu') hidePreview()
          return
        }
        if (filteredMentions.value.length > 0 && mentionIndex.value >= filteredMentions.value.length) {
          mentionIndex.value = filteredMentions.value.length - 1
          return
        }
        nextTick(() => {
          requestAnimationFrame(showSelectedMentionPreview)
        })
      },
      { flush: 'post' }
    )



    const onPreviewMouseEnter = () => {


      previewCoverHovered.value = true

    }



    const onPreviewPointerDown = () => {


      previewCoverHovered.value = true
      previewPointerInteracting.value = true

      if (previewInteractTimer) clearTimeout(previewInteractTimer)

      previewInteractTimer = setTimeout(() => {
        previewPointerInteracting.value = false
        previewInteractTimer = null
      }, 300)

    }



    const onPreviewMouseLeave = (event) => {

      previewCoverHovered.value = false
      if (previewAnchorEl?.contains(event.relatedTarget)) return
      if (previewCover.source === 'mention-menu') mentionPreviewEnabled = false
      hidePreview()

    }

    // 全屏预览
    const openFullscreenPreview = () => {
      if (!previewCover.url || fullscreenOverlay) return
      const url = previewCover.url
      const type = previewCover.type
      // Keep the mention list, selection and scroll position below the fullscreen layer.
      hidePreview()

      const overlay = document.createElement('div')
      overlay.className = 'fullscreen-preview-overlay'
      overlay.tabIndex = -1
      overlay.setAttribute('role', 'dialog')
      overlay.setAttribute('aria-modal', 'true')
      overlay.setAttribute('aria-label', '素材全屏预览')

      const content = document.createElement('div')
      content.className = 'fullscreen-preview-content'
      content.addEventListener('click', (e) => e.stopPropagation())

      if (type === 'video') {
        const video = document.createElement('video')
        video.src = url
        video.controls = true
        video.autoplay = true
        video.className = 'fullscreen-preview-video'
        content.appendChild(video)
      } else if (type === 'audio') {
        const wrapper = document.createElement('div')
        wrapper.className = 'fullscreen-preview-audio-wrapper'
        const audio = document.createElement('audio')
        audio.src = url
        audio.controls = true
        audio.autoplay = true
        audio.className = 'fullscreen-preview-audio'
        wrapper.appendChild(audio)
        content.appendChild(wrapper)
      } else {
        const img = document.createElement('img')
        img.src = url
        img.className = 'fullscreen-preview-img'
        content.appendChild(img)
      }

      const closeBtn = document.createElement('div')
      closeBtn.className = 'fullscreen-preview-close'
      closeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="24" height="24" fill="currentColor"><path d="M764.288 252.736 512 505.024 259.712 252.736a16 16 0 0 0-22.624 22.624L489.376 527.68 237.088 780.032a16 16 0 1 0 22.624 22.592L512 550.336l252.288 252.288a16 16 0 0 0 22.624-22.592L534.624 527.68l252.288-252.32a16 16 0 1 0-22.624-22.624z"/></svg>'
      content.appendChild(closeBtn)

      overlay.appendChild(content)
      document.body.appendChild(overlay)
      fullscreenOverlay = overlay
      overlay.focus({ preventScroll: true })

      // 触发动画
      requestAnimationFrame(() => overlay.classList.add('active'))

      let closeTimer = null
      const dispose = (restoreFocus = false) => {
        if (closeTimer !== null) clearTimeout(closeTimer)
        overlay.querySelector('video')?.pause()
        overlay.querySelector('audio')?.pause()
        overlay.remove()
        // Restore focus while the fullscreen guard still protects the current selection.
        if (restoreFocus && showMentionMenu.value) editorRef.value?.focus({ preventScroll: true })
        fullscreenOverlay = null
        disposeFullscreenPreview = null
      }
      disposeFullscreenPreview = dispose

      const close = () => {
        if (closeTimer !== null) return
        overlay.querySelector('video')?.pause()
        overlay.querySelector('audio')?.pause()
        overlay.classList.remove('active')
        overlay.classList.add('closing')
        closeTimer = setTimeout(() => dispose(true), 200)
      }

      overlay.addEventListener('click', close)
      closeBtn.addEventListener('click', close)
      overlay.addEventListener('keydown', (event) => {
        event.stopPropagation()
        if (event.key === 'Escape') {
          event.preventDefault()
          close()
        }
      })
    }

    

    const handlePreviewMediaError = () => {

      previewCover.loadError = true
      syncPreviewStyleToAnchor(getPreviewUnavailableSize(previewCover.type))

    }

    const handleImageError = handlePreviewMediaError



    const handleKeydown = (e) => {

      if (e.key === 'Enter' && !e.isComposing) {

        if (!e.shiftKey && showMentionMenu.value && filteredMentions.value.length > 0) {

          e.preventDefault()

          selectMention(filteredMentions.value[mentionIndex.value])

          return

        }

        // 统一两种回车的 DOM 表示，避免 pre-wrap 下 Shift+Enter 插入额外的占位换行。
        e.preventDefault()
        document.execCommand('insertParagraph', false)
        return

      }

      

      if (e.key === 'Backspace') {

        const selection = window.getSelection()

        if (selection.rangeCount > 0) {

          const range = selection.getRangeAt(0)

          if (range.collapsed && range.startOffset === 0) {

            const prevNode = range.startContainer.previousSibling

            if (prevNode && prevNode.nodeType === Node.ELEMENT_NODE && prevNode.classList.contains('mention-chip')) {

              // no action needed for adjacent mention chip

            }

          }

        }

      }



      if (showMentionMenu.value && e.key === 'Escape') {
        e.preventDefault()
        closeMentionMenu()
        return
      }

      if (showMentionMenu.value && filteredMentions.value.length > 0) {

        if (e.key === 'ArrowUp') {

          e.preventDefault()
          e.stopPropagation()

          setMentionIndex((mentionIndex.value - 1 + filteredMentions.value.length) % filteredMentions.value.length, { scroll: true })

          return

        }

        if (e.key === 'ArrowDown') {

          e.preventDefault()
          e.stopPropagation()

          setMentionIndex((mentionIndex.value + 1) % filteredMentions.value.length, { scroll: true })

          return

        }

      }

    }



    const getSidebarWidth = () => {
      if (window.innerWidth <= 900 || document.querySelector('.video-list-container.navigation-collapsed')) return 0
      return 250
    }

    const getPanelWidthBounds = () => {
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0
      const availableWidth = Math.max(0, viewportWidth - getSidebarWidth())
      const max = Math.max(1, Math.floor(availableWidth / 2))
      const min = Math.min(360, max)
      return { min, max }
    }

    const applyPanelWidth = (width) => {
      const { min, max } = getPanelWidthBounds()
      const nextWidth = Math.min(max, Math.max(min, Math.round(width)))
      panelWidth.value = nextWidth
      document.documentElement.style.setProperty('--generate-panel-width', `${nextWidth}px`)
      emit('panel-resize', { width: nextWidth, resizing: isPanelResizing.value })
      return nextWidth
    }

    const handlePanelViewportResize = () => {
      applyPanelWidth(panelWidth.value)
    }

    const handlePanelResizeMove = (event) => {
      if (!isPanelResizing.value) return
      const nextWidth = (window.innerWidth || document.documentElement.clientWidth || 0) - event.clientX
      if (panelResizeRaf) cancelAnimationFrame(panelResizeRaf)
      panelResizeRaf = requestAnimationFrame(() => {
        panelResizeRaf = null
        applyPanelWidth(nextWidth)
      })
    }

    const stopPanelResize = () => {
      if (!isPanelResizing.value) return
      isPanelResizing.value = false
      document.body.classList.remove('generate-panel-resizing')
      document.removeEventListener('mousemove', handlePanelResizeMove)
      document.removeEventListener('mouseup', stopPanelResize)
      emit('panel-resize', { width: panelWidth.value, resizing: false, persist: true })
    }

    const startPanelResize = (event) => {
      if (workspaceDisabled.value || window.innerWidth <= 900) return
      isPanelResizing.value = true
      document.body.classList.add('generate-panel-resizing')
      document.addEventListener('mousemove', handlePanelResizeMove)
      document.addEventListener('mouseup', stopPanelResize)
      handlePanelResizeMove(event)
    }

    onMounted(() => {

      window.addEventListener('resize', handlePanelViewportResize)

      forceReloadScheduleList()

      loadAssetGroups()

      if (props.prompt && editorRef.value) {

        editorRef.value.innerHTML = formatTextToHtml(props.prompt)

      }

      nextTick(updateAssetScrollHints)
      nextTick(() => applyPanelWidth(panelWidth.value))

    })

    onActivated(() => { void loadVolcAssets({ silent: true }) })

    const stopVolcAssetsChanged = onVolcAssetsChanged(({ scriptId } = {}) => {
      if (scriptId && props.scriptId && String(scriptId) !== String(props.scriptId)) return
      loadVolcAssets({ force: true, silent: true })
    })

    onUnmounted(() => {
      disposeFullscreenPreview?.()
      window.removeEventListener('resize', handlePanelViewportResize)
      stopPanelResize()
      if (panelResizeRaf) {
        cancelAnimationFrame(panelResizeRaf)
        panelResizeRaf = null
      }
      stopVolcAssetsChanged()
      for (const item of [...seedanceImages.value, ...seedanceVideos.value, ...seedanceAudios.value]) {
        if (item.localUrl) URL.revokeObjectURL(item.localUrl)
      }
    })



    const updateSingleGroupScrollState = (group) => {

      const items = group.querySelector('.asset-items')

      if (!items) return

      const hasScroll = items.scrollWidth > items.clientWidth + 2

      const atStart = items.scrollLeft <= 2

      const atEnd = items.scrollLeft + items.clientWidth >= items.scrollWidth - 2

      group.classList.toggle('has-scroll', hasScroll)

      group.classList.toggle('scroll-start', atStart || !hasScroll)

      group.classList.toggle('scroll-end', atEnd || !hasScroll)

    }



    const updateAssetScrollHints = () => {

      document.querySelectorAll('.seedance-assets-bar .asset-group').forEach(updateSingleGroupScrollState)

    }



    const handleAssetItemsScroll = (e) => {

      const el = e.currentTarget

      const group = el.closest('.asset-group')

      if (group) updateSingleGroupScrollState(group)

    }



    const handleAssetItemsWheel = (e) => {

      const el = e.currentTarget

      if (el.scrollWidth <= el.clientWidth) return

      e.preventDefault()

      el.scrollLeft += e.deltaY

    }

    const getSeedanceAssetPreviewUrl = (asset, type) => {
      if (!asset) return ''

      const rawUrl = type === 'image'
        ? (asset.localUrl || getPreviewableUrl(asset.sourceUrl, asset.url, asset.volcAssetCover) || getVolcAssetCover(asset))
        : type === 'video'
          ? (asset.localUrl || asset.url || '')
          : (asset.url || asset.localUrl || '')

      return resolveVolcCoverUrl(rawUrl) || rawUrl
    }

    const showSeedanceAssetPreview = (event, asset, type) => {
      if (fullscreenOverlay) return
      const url = getSeedanceAssetPreviewUrl(asset, type)

      if (!url || url === 'null' || url === 'undefined' || url.startsWith('asset://')) {
        hidePreview()
        return
      }

      const target = event.currentTarget
      if (!target) return

      if (previewCover.show && previewAnchorEl === target && previewCover.source === 'asset-thumb' && previewCover.url === url && previewCover.type === type) return
      const loadError = getPreviewLoadErrorState(url, type, 'asset-thumb')
      setPreviewAnchor(target)

      previewCover.url = url
      previewCover.type = type
      previewCover.source = 'asset-thumb'
      previewCover.name = getPreviewReferenceName(asset, MEDIA_PREFIX[type])
      previewCover.loadError = loadError
      previewCover.show = true
      syncPreviewStyleToAnchor(loadError ? getPreviewUnavailableSize(type) : {})
    }

    let assetMouseFollowRaf = null

    let assetMouseFollowTarget = null



    const handleAssetMouseMove = (e) => {

      const el = e.currentTarget

      if (el.scrollWidth <= el.clientWidth + 2) return

      assetMouseFollowTarget = el

      if (assetMouseFollowRaf) return

      assetMouseFollowRaf = requestAnimationFrame(() => {

        const target = assetMouseFollowTarget

        assetMouseFollowRaf = null

        if (!target) return

        const rect = target.getBoundingClientRect()

        const ratio = (e.clientX - rect.left) / rect.width

        const maxScroll = target.scrollWidth - target.clientWidth

        const scrollPos = ratio * maxScroll

        target.scrollLeft = scrollPos

      })

    }



    const handleAssetMouseLeave = (event) => {

      assetMouseFollowTarget = null

      if (assetMouseFollowRaf) {

        cancelAnimationFrame(assetMouseFollowRaf)

        assetMouseFollowRaf = null

      }

      if (previewCover.source === 'asset-thumb' && !event.relatedTarget?.closest?.('.mention-media-preview')) {
        hidePreview()
      }

    }



    watch([seedanceImages, seedanceVideos, seedanceAudios], () => {

      nextTick(updateAssetScrollHints)

    })



    const openRemarkDialog = () => {

      if (blurTimer) clearTimeout(blurTimer)

      tempRemark.value = localRemark.value || '' 

      showRemarkDialog.value = true

      nextTick(() => { remarkInputRef.value?.focus() })

    }



    const confirmRemark = () => {

      localRemark.value = tempRemark.value

      emit('update:remark', tempRemark.value)

      showRemarkDialog.value = false

      nextTick(() => {

        isExpandedMode.value = true

        isInputFocused.value = true

        if (editorRef.value) editorRef.value.focus()

        updateWrapperHeight()

      })

    }



    const handleGenerate = async () => {

      if (!props.currentWorkspaceId) {

        ElMessage.warning('请选择工作空间')

        return

      }

      if (isSeedancePlatform.value) {

        const hasUploading = seedanceImages.value.some(i => i.uploading || i.validating) ||

          (showSeedanceVideoReference && seedanceVideos.value.some(v => v.uploading || v.validating)) ||

          seedanceAudios.value.some(a => a.uploading || a.validating)

        if (hasUploading) {

          ElMessage.warning('请等待文件上传完成')

          return

        }

        if (hasUnusedSeedanceAssets.value) {

          ElMessage.warning('有未使用的参考资源，请在描述中用 @引用')

          return

        }

      }



      if (showRemarkDialog.value) {

        localRemark.value = tempRemark.value

        emit('update:remark', localRemark.value)

        showRemarkDialog.value = false

        await nextTick()

      }

      let text = editorRef.value ? getEditorText() : modelPrompt.value

      const payload = {

        prompt: text,

        remark: localRemark.value

      }

      if (isSeedancePlatform.value) {

          payload.images = seedanceImages.value

          .filter(i => i.url || i.file)

          .map(i => ({
            file: i.file,
            url: usesPublicReferenceUrls.value ? getWanReferenceUrl(i, 'Image') : i.url,
            role: usesPublicReferenceUrls.value ? 'reference_image' : i.role,
            isVolcAsset: Boolean(resolveSelectedVolcAssetMeta(i, 'Image')),
            volcAssetId: getSelectedVolcAssetId(i, 'Image') || undefined,
            name: i.volcAssetName || i.fileName || undefined,
            assetType: 'Image'
          }))

        payload.videos = showSeedanceVideoReference ? seedanceVideos.value

          .filter(v => v.url || v.file)

          .map(v => ({
            file: v.file,
            url: usesPublicReferenceUrls.value ? getWanReferenceUrl(v, 'Video') : v.url,
            duration: v.duration || undefined,
            isVolcAsset: Boolean(resolveSelectedVolcAssetMeta(v, 'Video')),
            volcAssetId: getSelectedVolcAssetId(v, 'Video') || undefined,
            name: v.volcAssetName || v.fileName || undefined,
            assetType: 'Video'
          })) : []

        payload.audios = seedanceAudios.value

          .filter(a => a.url || a.file)

          .map(a => ({
            file: a.file,
            url: usesPublicReferenceUrls.value ? getWanReferenceUrl(a, 'Audio') : a.url,
            duration: a.duration || undefined,
            isVolcAsset: Boolean(resolveSelectedVolcAssetMeta(a, 'Audio')),
            volcAssetId: getSelectedVolcAssetId(a, 'Audio') || undefined,
            name: a.volcAssetName || a.fileName || undefined,
            assetType: 'Audio'
          }))

      }



      if (!isSeedancePlatform.value) payload.inputFile = inputReferenceFile.value
      const referenceError = h3VideoPolicy.getReferenceError(props.platform, payload)
        || wan3ReferencePolicy.getWanReferenceError(props.platform, payload)
      if (referenceError) {
        ElMessage.warning(referenceError)
        return
      }
      emit('generate', payload)

    }



    const updateWrapperHeight = () => {

      if (!isExpandedMode.value) {

        wrapperStyle.value = {}

        return

      }

      // expanded-layout 模式下由 CSS flex 控制高度，避免行内 height 覆盖卡片布局
      wrapperStyle.value = {}

    }

    

    const handleTextareaWheel = (e) => {

      if (!isExpandedMode.value) return

      const el = e.currentTarget

      const { scrollTop, scrollHeight, clientHeight } = el

      const isScrollable = scrollHeight > clientHeight

      if (!isScrollable) {

        e.preventDefault()

      } else {

        if (e.deltaY < 0 && scrollTop <= 0) e.preventDefault()

        else if (e.deltaY > 0 && scrollTop + clientHeight >= scrollHeight - 1) e.preventDefault()

      }

    }



    const clearPrompt = () => {

      emit('update:prompt', '')

      if (editorRef.value) editorRef.value.innerHTML = ''

      nextTick(() => {

        updateWrapperHeight()

        editorRef.value?.focus()

      })

    }

    const resetAfterGenerateSuccess = () => {
      removeImage()

      isLocked.value = false

      if (editorRef.value) editorRef.value.innerHTML = ''

      localRemark.value = ''

      tempRemark.value = ''

      inputReferenceLocal.value = ''

      clearSeedanceAssets()

      nextTick(updateWrapperHeight)

    }



    const activeMenu = ref(null)

    const platformPopoverVisible = ref(false)
    const sizePopoverVisible = ref(false)
    const durationPopoverVisible = ref(false)

    watch(workspaceDisabled, (disabled) => {
      if (!disabled) return
      platformPopoverVisible.value = false
      sizePopoverVisible.value = false
      durationPopoverVisible.value = false
      showRemarkDialog.value = false
      uploadAsAssetDialogVisible.value = false
      isDragOver.value = false
      closeMentionMenu()
      hidePreview()
      editorRef.value?.blur()
      stopPanelResize()
    })

    const openTagPopover = (name) => {
      if (name !== 'platform') platformPopoverVisible.value = false
      if (name !== 'size') sizePopoverVisible.value = false
      if (name !== 'duration') durationPopoverVisible.value = false
    }

    const SIZE_RESOLUTION_TIER = Object.freeze({
      '864x496': '480',
      '496x864': '480',
      '1280x720': '720',
      '720x1280': '720',
      '1920x1080': '1080',
      '1080x1920': '1080',
      '1440x1440': '1080',
      '1664x1248': '1080',
      '1248x1664': '1080'
    })

    const SIZE_LABELS = Object.freeze({
      '864x496': '480p 横屏',
      '496x864': '480p 竖屏',
      '1280x720': '720p 横屏',
      '720x1280': '720p 竖屏',
      '1920x1080': '1080p 横屏',
      '1080x1920': '1080p 竖屏',
      '1440x1440': '1080p 方形',
      '1664x1248': '1080p 4:3',
      '1248x1664': '1080p 3:4'
    })

    const resolutionToneClass = (size) => {
      const tier = SIZE_RESOLUTION_TIER[size]
      return tier ? `resolution-tone-${tier}` : ''
    }

    const resolutionPreviewStyle = (size) => {
      const [width, height] = String(size).split(/[x:]/).map(Number)
      if (!(width > 0) || !(height > 0)) return { width: '24px', height: '16px' }

      const scale = Math.min(34 / width, 22 / height)
      return {
        width: `${Math.round(width * scale * 100) / 100}px`,
        height: `${Math.round(height * scale * 100) / 100}px`
      }
    }

    const sizeLabel = computed(() => SIZE_LABELS[props.size] || props.size)

    const isSeedanceFastPlatform = computed(() => props.platform === 'seedance-fast')

    const displayPlatformDefinitions = [
      { value: 'seedance', label: 'SD2.0', icon: 'seedance', logo: bytedanceLogo },
      { value: 'seedance-fast', label: 'SD2.0 FAST', icon: 'seedance', logo: bytedanceLogo },
      { value: 'wan3', label: 'Wan 3.0', icon: 'wan', logo: wanLogo },
      { value: 'wan3-cd', label: 'Wan3-CD', icon: 'wan', logo: wanLogo },
      { value: 'runninghub-h3', label: 'H3', icon: 'h3', logo: h3Logo, alwaysVisible: true }
    ]

    const getPlatformOption = (platformCode) => props.platformOptions.find(item => item.platformCode === platformCode)

    const selectedDisplayPlatform = computed(() => {
      return displayPlatformDefinitions.some(item => item.value === props.platform) ? props.platform : ''
    })

    const displayPlatformOptions = computed(() => displayPlatformDefinitions
      .filter(item => item.alwaysVisible || item.disabled || getPlatformOption(item.value) || item.value === props.platform)
      .map(item => ({ ...item, platformCode: item.value, disabled: item.disabled || !getPlatformOption(item.value) })))

    const platformLabel = computed(() => {
      const target = displayPlatformOptions.value.find(item => item.value === selectedDisplayPlatform.value)
      return target?.label || '请选择'
    })

    const platformLogo = computed(() => displayPlatformOptions.value.find(item => item.value === selectedDisplayPlatform.value)?.logo)

    const isFastPlatform = computed(() => {

      const target = props.platformOptions.find(p => p.platformCode === props.platform)

      return props.platform === 'seedance-fast' || target?.platformName === 'FAST'

    })

    const submenuTitle = computed(() => { const titles = { duration: '选择时长', size: '选择尺寸', batch: '批量生成次数', platform: '选择平台' }; return titles[activeMenu.value] || '设置' })

    const openMenu = (menuName) => { activeMenu.value = menuName }

    const backToMain = () => { activeMenu.value = null }

    const resetMenuState = () => { activeMenu.value = null }

    const selectOption = (type, value) => { emit(`update:${type}`, value); backToMain() }

    const selectDisplayPlatform = (value) => {
      const target = displayPlatformOptions.value.find(item => item.value === value)
      if (!target || target.disabled) return

      emit('update:platform', target.platformCode)
      platformPopoverVisible.value = false
      backToMain()
    }

    

    const syncInputReference = (val) => { inputReferenceLocal.value = val; emit('update:inputReference', val) }

    

    watch(() => props.inputReference, async (newVal) => {

      if (newVal !== previewObjectUrl.value) inputReferenceFile.value = null
      inputReferenceLocal.value = newVal || ''

      nextTick(updateWrapperHeight)

    })

    

    const uploadImageFile = (imageFile) => {

      if (workspaceDisabled.value) return

      if (inputReferenceLocal.value) { ElMessage.warning('只能上传一张图片，请先删除当前图片后再上传'); return }

      if (!imageFile.type.startsWith('image/')) { ElMessage.error('请上传图片文件'); return }

      if (imageFile.size > 15 * 1024 * 1024) { ElMessage.error('图片大小不能超过15MB'); return }

      try {

        const objectUrl = URL.createObjectURL(imageFile)

        previewObjectUrl.value = objectUrl

        isObjectUrlPreview.value = true

        syncInputReference(objectUrl)

      } catch (e) { console.warn('[Debug] Failed to create object URL', e) }

      inputReferenceFile.value = imageFile
      imageUploading.value = false
    }


    const onImageChange = (file) => {

      const imageFile = file.raw; if (!imageFile) return

      if (inputReferenceLocal.value) { ElMessage.warning('只能上传一张图片，请先删除当前图片后再上传'); return }

      uploadImageFile(imageFile)

    }



    const insertSeedanceMentionChip = (uuid, coverUrl, type) => {

      if (!editorRef.value) return

      editorRef.value.focus()



      const selection = window.getSelection()

      if (!selection.rangeCount) return



      const range = selection.getRangeAt(0)

      range.collapse(false) 



      const chip = createMentionChip(uuid, coverUrl, normalizeMentionType(type))



      const zeroSpaceBefore = document.createTextNode('\u200B')

      const spaceAfter = document.createTextNode('\u2009')



      const fragment = document.createDocumentFragment()

      fragment.appendChild(zeroSpaceBefore)

      fragment.appendChild(chip)

      fragment.appendChild(spaceAfter)



      range.insertNode(fragment)



      range.setStartAfter(spaceAfter)

      range.setEndAfter(spaceAfter)

      selection.removeAllRanges()

      selection.addRange(range)



      isLocked.value = true

      emit('update:prompt', getEditorText())

      updateWrapperHeight()

    }



    const SEEDREAM_URL_PREFIX = 'https://ark-acg-cn-beijing.tos-cn-beijing.volces.com/doubao-seedream'

    const handlePaste = (event) => {

      event.preventDefault()

      if (workspaceDisabled.value) return

      const rawText = (event.clipboardData || window.clipboardData).getData('text/plain')
      const text = rawText.replace(/\n{2,}/g, '\n\n').replace(/^\n+/, '').replace(/\n+$/, '')

      const seedreamUrlMatch = text.match(new RegExp(`(${SEEDREAM_URL_PREFIX.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\S+)`))

      if (seedreamUrlMatch && isSeedancePlatform.value) {
        const imageUrl = seedreamUrlMatch[1]
        const remainingText = text.replace(imageUrl, '').trim()
        if (remainingText) document.execCommand('insertText', false, remainingText)

        if (seedanceImages.value.length >= 9) {
          ElMessage.warning('最多上传9张图片')
        } else {
          seedanceImages.value = [...seedanceImages.value, reactive({ url: imageUrl, localUrl: '', uploading: false, role: 'reference', fileName: 'seedream.jpg' })]
          insertSeedanceMentionChip(`图片${seedanceImages.value.length}`, imageUrl, 'image')
        }
        emit('paste', event)
        return
      }

      document.execCommand('insertText', false, text)



      const items = event.clipboardData?.items

      if (!items) { emit('paste', event); return }



      if (isSeedancePlatform.value) {

        const limitHints = []

        for (let i = 0; i < items.length; i++) {

          const item = items[i]

          const file = item.getAsFile()

          if (!file) continue



          if (item.type.startsWith('image/')) {

            if (!onSeedanceFileChange({ raw: file }, 'image', { silent: true })) { limitHints.push('图片最多9张'); continue }

            const newImg = seedanceImages.value[seedanceImages.value.length - 1]

            insertSeedanceMentionChip(

              `图片${seedanceImages.value.length}`,

              newImg?.url || newImg?.localUrl || '',

              'image'

            )

          } else if (showSeedanceVideoReference && item.type.startsWith('video/')) {

            if (!onSeedanceFileChange({ raw: file }, 'video', { silent: true })) { limitHints.push('视频最多3个'); continue }

            const newVid = seedanceVideos.value[seedanceVideos.value.length - 1]

            insertSeedanceMentionChip(

              `视频${seedanceVideos.value.length}`,

              newVid?.url || newVid?.localUrl || '',

              'video'

            )

          } else if (item.type.startsWith('audio/')) {

            if (!onSeedanceFileChange({ raw: file }, 'audio', { silent: true })) { limitHints.push('音频最多3个'); continue }

            insertSeedanceMentionChip(`音频${seedanceAudios.value.length}`, '', 'audio')

          }

        }

        if (limitHints.length > 0) {

          ElMessage.warning([...new Set(limitHints)].join('，'))

        }

      } else {

        for (let i = 0; i < items.length; i++) {

          const item = items[i]

          if (item.type.startsWith('image/')) {

            if (inputReferenceLocal.value) { ElMessage.warning('只能上传一张图片，请先删除当前图片后再上传'); return }

            const file = item.getAsFile(); if (file) uploadImageFile(file); break

          }

        }

      }

      emit('paste', event)

    }



    const handleDrop = (event) => {

      if (workspaceDisabled.value || !isSeedancePlatform.value) return

      const files = event.dataTransfer?.files

      if (!files || !files.length) return



      const limitHints = []

      for (let i = 0; i < files.length; i++) {

        const file = files[i]

        if (file.type.startsWith('image/')) {

          if (!onSeedanceFileChange({ raw: file }, 'image', { silent: true })) { limitHints.push('图片最多9张'); continue }

          const newImg = seedanceImages.value[seedanceImages.value.length - 1]

          insertSeedanceMentionChip(`图片${seedanceImages.value.length}`, newImg?.url || newImg?.localUrl || '', 'image')

        } else if (showSeedanceVideoReference && file.type.startsWith('video/')) {

          if (!onSeedanceFileChange({ raw: file }, 'video', { silent: true })) { limitHints.push('视频最多3个'); continue }

          const newVid = seedanceVideos.value[seedanceVideos.value.length - 1]

          insertSeedanceMentionChip(`视频${seedanceVideos.value.length}`, newVid?.url || newVid?.localUrl || '', 'video')

        } else if (file.type.startsWith('audio/')) {

          if (!onSeedanceFileChange({ raw: file }, 'audio', { silent: true })) { limitHints.push('音频最多3个'); continue }

          insertSeedanceMentionChip(`音频${seedanceAudios.value.length}`, '', 'audio')

        }

      }

      if (limitHints.length > 0) {

        ElMessage.warning([...new Set(limitHints)].join('，'))

      }

    }

    const onDragOver = () => {
      if (workspaceDisabled.value) return
      isDragOver.value = true
    }

    const onDragLeave = () => {
      isDragOver.value = false
    }

    const handleContainerDrop = (event) => {
      isDragOver.value = false
      handleDrop(event)
    }


    const flashAssetThumb = (type, idx) => {

      const prefix = type === 'image' ? 'seedance-img' : type === 'video' ? 'seedance-vid' : 'seedance-aud'

      const el = document.getElementById(`${prefix}-${idx}`)

      if (!el) return

      el.classList.remove('highlight-flash')

      void el.offsetWidth

      el.classList.add('highlight-flash')

      el.addEventListener('animationend', () => el.classList.remove('highlight-flash'), { once: true })

    }



    const handleEditorClick = (e) => {

      if (isSeedancePlatform.value) {

        const target = getMentionChipTarget(e)

        if (target && target.classList.contains('mention-chip')) {

          const type = target.getAttribute('data-mention-type') || ''

          const text = getMentionChipText(target)

          if (type === 'image') {

            const m = text.match(/图片(\d+)/)

            if (m) flashAssetThumb('image', parseInt(m[1]) - 1)

          } else if (type === 'video') {

            const m = text.match(/视频(\d+)/)

            if (m) flashAssetThumb('video', parseInt(m[1]) - 1)

          } else if (type === 'audio') {

            const m = text.match(/音频(\d+)/)

            if (m) flashAssetThumb('audio', parseInt(m[1]) - 1)

          }

        }

      }

      nextTick(() => { checkMentionAtCursor() })

    }



    const showImagePreview = () => { if (inputReferenceLocal.value) window.open(inputReferenceLocal.value, '_blank') }

    const removeImage = () => {
      inputReferenceFile.value = null

      if (isObjectUrlPreview.value && previewObjectUrl.value) {

        try { URL.revokeObjectURL(previewObjectUrl.value) } catch (e) { /* ignore */ }

        previewObjectUrl.value = ''

        isObjectUrlPreview.value = false

      }

      syncInputReference('')

    }

    

    const handleWrapperMouseDown = (event) => {

      // Let native editor clicks place the caret at the clicked text position.
      if (editorRef.value?.contains(event.target)) return

      if (editorRef.value && document.activeElement !== editorRef.value) {

        editorRef.value.focus()

        const range = document.createRange()

        const sel = window.getSelection()

        range.selectNodeContents(editorRef.value)

        range.collapse(false)

        sel.removeAllRanges()

        sel.addRange(range)

      }

    }



    const handleInputFocus = () => {
      const preserveMentionSelection = Boolean(fullscreenOverlay && showMentionMenu.value)

      if (blurTimer) clearTimeout(blurTimer)

      isInputFocused.value = true

      isExpandedMode.value = true

      emit('input-focus')

      wrapperStyle.value = {}

      nextTick(() => {

        updateWrapperHeight()

        if (!preserveMentionSelection) checkMentionAtCursor()

      })

    }



    const handleInputBlur = (event) => {

      blurTimer = setTimeout(() => {

        if (fullscreenOverlay || previewCoverHovered.value || previewPointerInteracting.value) {
          return
        }

        isInputFocused.value = false

        emit('input-blur', event)

        showMentionMenu.value = false

        mentionMenuStyle.value = {}

      }, 200)

    }



    const setSeedanceAssets = async ({ images = [], videos = [], audios = [] } = {}) => {
      clearSeedanceAssets()

      seedanceImages.value = images.map(i => {

        const assetMeta = resolveSelectedVolcAssetMeta(i, 'Image')
        const isVolcAsset = Boolean(assetMeta)
        const originalUrl = referenceDisplayUrl(i)
        const url = usesPublicReferenceUrls.value ? getWanReferenceUrl({ ...i, url: originalUrl }, 'Image') : originalUrl

        return {

          url,
          sourceUrl: assetMeta?.sourceUrl || i.sourceUrl || (url !== originalUrl ? url : ''),

          localUrl: assetMeta?.coverUrl || i.localUrl || '',
          volcAssetCover: assetMeta?.coverUrl || '',

          uploading: false,

          role: i.role || 'reference',

          fileName: assetMeta?.name || i.fileName || i.name || '',

          isVolcAsset,

          volcAssetId: assetMeta?.assetId || undefined,

          volcAssetName: assetMeta?.name || i.name || ''

        }

      })

      seedanceVideos.value = videos.map(v => {
        const assetMeta = resolveSelectedVolcAssetMeta(v, 'Video')
        const originalUrl = referenceDisplayUrl(v)
        const url = usesPublicReferenceUrls.value ? getWanReferenceUrl({ ...v, url: originalUrl }, 'Video') : originalUrl

        return {
          url,
          sourceUrl: assetMeta?.sourceUrl || v.sourceUrl || (url !== originalUrl ? url : ''),
          localUrl: v.localUrl || '',
          uploading: false,
          fileName: assetMeta?.name || v.fileName || v.name || '',
          duration: v.duration || 0,
          isVolcAsset: Boolean(assetMeta),
          volcAssetId: assetMeta?.assetId || v.volcAssetId || v.assetId || undefined,
          volcAssetName: assetMeta?.name || v.name || ''
        }
      })

      seedanceAudios.value = audios.map(a => {
        const assetMeta = resolveSelectedVolcAssetMeta(a, 'Audio')
        const originalUrl = referenceDisplayUrl(a)
        const url = usesPublicReferenceUrls.value ? getWanReferenceUrl({ ...a, url: originalUrl }, 'Audio') : originalUrl

        return {
          url,
          sourceUrl: assetMeta?.sourceUrl || a.sourceUrl || (url !== originalUrl ? url : ''),
          localUrl: a.localUrl || '',
          uploading: false,
          fileName: assetMeta?.name || a.fileName || a.name || '',
          duration: a.duration || 0,
          isVolcAsset: Boolean(assetMeta),
          volcAssetId: assetMeta?.assetId || a.volcAssetId || a.assetId || undefined,
          volcAssetName: assetMeta?.name || a.name || ''
        }
      })

      // Copy restores references after the prompt/platform watchers have run.
      // Rebuild chips even when the copied text is identical to the current prompt.
      await nextTick()
      isLocked.value = false
      if (editorRef.value) editorRef.value.innerHTML = formatTextToHtml(modelPrompt.value)
      updateWrapperHeight()

    }



    return {

      workspaceDisabled, platformLogo,
      assetLibraryVisible, assetLibraryItems, assetLibraryLimits, openAssetLibrary, addLibraryReferences, onLibraryAssetDeleted,
      volcAssetsLoading, volcAssetsError, loadVolcAssets,

      modelPrompt, modelSeconds, modelSize, modelPlatform, modelBatchCount, localRemark,

      sizeLabel, platformLabel, displayPlatformOptions, selectedDisplayPlatform, resolutionToneClass, resolutionPreviewStyle, formatPlatformLabel, isFastPlatform, isSeedanceFastPlatform, isWan3Platform, isH3Platform, usesPublicReferenceUrls, submenuTitle, activeMenu, openMenu, backToMain, resetMenuState, selectOption, selectDisplayPlatform,
      platformPopoverVisible, sizePopoverVisible, durationPopoverVisible, openTagPopover,

      isInputFocused, isExpandedMode, imageUploading, isPanelResizing, inputReferenceLocal, editorRef, innerWrapperRef, wrapperStyle, promptContainerStyle, remarkInputRef,
      settingsCollapsed, toggleSettingsCollapsed,

      onImageChange, handlePaste, handleDrop, handleContainerDrop, onDragOver, onDragLeave, startPanelResize, handleEditorClick, handleGenerate, showImagePreview, removeImage,

      handleInputFocus, handleInputBlur, handleKeydown, handleEditorInput, handleEditorCopy, handleEditorCut, handleTextareaWheel, clearPrompt, handleWrapperMouseDown,
      resetAfterGenerateSuccess,

      showRemarkDialog, tempRemark, openRemarkDialog, confirmRemark,



      referenceThumbnailUrl, visibleMentionRows, mentionWindowTop, mentionWindowBottom, onMentionScroll,
      filteredMentions, showMentionMenu, mentionIndex, mentionMenuStyle, mentionMenuRef, setMentionIndex, onMentionMouseEnter, onMentionMouseLeave, onMentionListScroll, selectMention, closeMentionMenu, formattedModelPrompt,

      previewCover, previewImageUrl, previewImageSize, handlePreviewImageLoad, getOssImageCrossorigin, previewVideoRef, previewAudioRef, previewUnavailableText, handleHover, handleHoverOut, handleImageError, handlePreviewMediaError, onPreviewMouseEnter, onPreviewMouseLeave, onPreviewPointerDown, getVolcAssetCover, resolveVolcCoverUrl,
      openFullscreenPreview,



      isSeedancePlatform, showSeedanceVideoReference, seedanceImages, seedanceVideos, seedanceAudios, unusedSeedanceAssets, hasUnusedSeedanceAssets, hasUploadingAssets, referenceValidationMessage, hasSeedanceAssets, hasSeedanceAssetCapacity,

      onSeedanceFileChange, onSeedanceReferenceFileChange, removeSeedanceImage, removeSeedanceVideo, removeSeedanceAudio, clearSeedanceAssetType, clearAllSeedanceAssetReferences,

      handleAssetItemsScroll, handleAssetItemsWheel, handleAssetMouseMove, handleAssetMouseLeave, showSeedanceAssetPreview, updateAssetScrollHints,

      durationOptions, durationTickItems, durationSliderValue, durationSliderMin, durationSliderMax, durationSliderStep,
      durationSliderStyle, isDurationFixed, durationInputValue, beginDurationEdit, handleDurationInput,
      commitDurationInput, cancelDurationInput, sizeOptions, setSeedanceAssets,
      sizeSegmentOptions, sizeSegmentStyle, sizeSegmentIndicatorStyle,
      modelSegmentOptions, modelSegmentStyle, modelSegmentIndicatorStyle,



      CircleClose, Plus, Loading, Close, Delete, EditPen, Picture, VideoPlay,
      nonAssetItems, hasVolcAssetViewPermission, hasVolcAssetUploadPermission, uploadAsAssetDialogVisible, uploadAsAssetSelectedGroup, uploadAsAssetItems, uploadAsAssetSubmitting, assetGroups,
      openUploadAsAssetDialog, handleUploadAsAsset

    }

  }

}

</script>



<style scoped>

.generate-wrapper { position: relative; }

.generate-container {

  container-type: inline-size;

  position: fixed; top: 64px; right: 0; bottom: 0; left: auto;

  width: var(--generate-panel-width, 392px);
  box-sizing: border-box;

  padding: 16px 18px; background: #fff; border-radius: 0;

  border: 0;
  border-left: 1px solid #d9e2ef;
  box-shadow: -8px 0 24px rgba(15, 23, 42, 0.08);

  z-index: 998; max-width: 50vw; margin: 0;

  display: flex;

  flex-direction: column;

  overflow: hidden;

  transition: width 0.22s ease, box-shadow 0.2s ease;

}

.generate-container.is-resizing {
  transition: none;
  user-select: none;
}

.generate-panel-content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
}

.generate-container.workspace-disabled {
  background: #f0f1f3;
  cursor: not-allowed;
}

.workspace-disabled .generate-panel-content {
  filter: grayscale(1);
  opacity: 0.5;
  pointer-events: none;
  user-select: none;
}

.workspace-required-notice {
  position: absolute;
  inset: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  background: rgba(240, 241, 243, 0.35);
  color: #dc2626;
  font-size: 18px;
  font-weight: 700;
  pointer-events: none;
}

.workspace-required-notice .el-icon {
  flex-shrink: 0;
  font-size: 22px;
}

.generate-resize-handle {
  position: absolute;
  left: -5px;
  top: 0;
  bottom: 0;
  width: 10px;
  cursor: col-resize;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
}

.generate-resize-handle::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 0;
  bottom: 0;
  width: 1px;
  background: transparent;
  transition: background 0.18s ease;
}

.generate-resize-handle span {
  width: 3px;
  height: 44px;
  border-radius: 999px;
  background: #cbd5e1;
  opacity: 0;
  transition: opacity 0.18s ease, background 0.18s ease, height 0.18s ease;
}

.generate-resize-handle:hover::before,
.generate-container.is-resizing .generate-resize-handle::before {
  background: rgba(24, 117, 240, 0.28);
}

.generate-resize-handle:hover span,
.generate-container.is-resizing .generate-resize-handle span {
  opacity: 1;
  background: #1875F0;
  height: 72px;
}

:global(body.generate-panel-resizing) {
  cursor: col-resize;
  user-select: none;
}

.generating-overlay {

  position: absolute; inset: 0; background: rgba(255,255,255,0.72);

  backdrop-filter: blur(4px); border-radius: 0; z-index: 900;

  display: flex; align-items: center; justify-content: center; cursor: not-allowed;

}

.generating-spinner {

  display: flex; align-items: center; gap: 10px;

  font-size: 15px; font-weight: 600; color: #1875F0;

}

.generating-spinner .el-icon { font-size: 22px; }

.generate-container.is-drag-over { box-shadow: -8px 0 24px rgba(15, 23, 42, 0.08), inset 0 0 0 3px rgba(64,158,255,0.25); }

.drag-over-overlay {
  position: absolute; inset: 0; background: rgba(255,255,255,0.72);
  backdrop-filter: blur(4px); border-radius: 0; z-index: 950;
  display: flex; align-items: center; justify-content: center;
}
.drag-over-inner { display: flex; align-items: center; gap: 10px; }
.drag-over-icon { font-size: 26px; color: #409eff; }
.drag-over-text { font-size: 15px; font-weight: 600; color: #409eff; }

:global(.sidebar-mini) .generate-container { left: auto; max-width: 50vw; }



.generate-form {
  width: 100%;
  height: 100%;
  max-width: none;
  min-height: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 12px;
  align-items: stretch;
}

/* === Prompt / Settings section wrappers ===
   Compact mode: display:contents lets the inner children flow as direct flex items
   of .generate-form, preserving the original single-row layout. */
.prompt-section {
  order: 2;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 220px;
  background: #f7f9fb;
  border: 1px solid #edf0f5;
  border-radius: 12px;
  padding: 12px;
  overflow: hidden;
}

.generate-form.has-reference-assets .prompt-section {
  min-height: 240px;
}

.settings-section {
  order: 3;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
  flex-shrink: 0;
  min-width: 0;
  padding-top: 12px;
  border-top: 1px solid #edf0f5;
}

.prompt-section .prompt-input-wrapper {
  flex: 1;
  align-items: stretch;
  min-height: 0;
}

.prompt-section .prompt-input-container {
  display: flex;
  flex: 1;
  min-height: 0;
}

.prompt-section .input-inner-wrapper {
  position: relative;
  left: auto;
  right: auto;
  bottom: auto;
  flex: 1;
  height: auto;
  min-height: 0;
  overflow: hidden;
}

.prompt-section .input-inner-wrapper:not(.expanded) {
  padding: 12px;
}

.prompt-section .input-inner-wrapper:not(.expanded) .rich-textarea {
  padding: 0;
  white-space: pre-wrap;
  overflow-y: auto;
}

.prompt-section .input-inner-wrapper:not(.expanded) .prompt-text-ellipsis {
  padding: 12px 36px 12px 12px;
  white-space: pre-wrap;
  overflow-y: auto;
}

.prompt-section .input-inner-wrapper:not(.expanded) .clear-btn {
  top: 12px;
  right: 12px;
  bottom: auto;
  transform: none;
}

/* === Expanded layout: card-based 2-column grid === */
.generate-form.expanded-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: stretch;
  height: 100%;
  min-height: 0;
}

.generate-form.expanded-layout > .seedance-assets-bar {
  width: 100%;
  margin: 0;
  padding: 0;
  order: 1;
}

.generate-form.expanded-layout > .prompt-section {
  display: flex;
  flex-direction: column;
  background: #f7f9fb;
  border-radius: 12px;
  padding: 12px;
  border: 1px solid #edf0f5;
  flex: 1 1 auto;
  min-height: 220px;
  overflow: hidden;
}

.generate-form.expanded-layout.has-reference-assets > .prompt-section {
  min-height: 240px;
}

.generate-form.expanded-layout > .settings-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.prompt-section-header,
.settings-card-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #2c3038;
  padding: 0 0 10px;
  user-select: none;
}

.section-header-icon { font-size: 16px; color: #1875F0; }

.generate-form.expanded-layout .prompt-input-wrapper {
  flex: 1;
  align-items: stretch;
  min-height: 0;
}

.generate-form.expanded-layout .prompt-input-container {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.generate-form.expanded-layout .input-inner-wrapper {
  position: relative;
  left: auto;
  right: auto;
  bottom: auto;
  flex: 1;
  height: auto;
  min-height: 0;
  overflow: hidden;
}

.generate-form.expanded-layout .input-inner-wrapper.expanded {
  border: none;
  background: transparent;
  padding: 0;
  gap: 0;
  box-shadow: none;
  z-index: auto;
}

.generate-form.expanded-layout .textarea-box {
  min-height: 0;
  overflow: hidden;
}

.generate-form.expanded-layout .rich-textarea {
  overflow-y: auto;
}

.generate-form.expanded-layout .clear-btn { display: none; }

.generate-form.expanded-layout .remark-tab-bar {
  top: -32px;
  right: 4px;
}

/* === Asset bar visual upgrade in expanded mode === */
.generate-form.expanded-layout .seedance-assets-bar {
  padding: 0;
  gap: 10px;
}

.generate-form.expanded-layout .asset-group {
  padding: 10px 10px 8px;
  background: #fafbfd;
  border-radius: 10px;
  border: 1px solid #eef0f5;
}

.generate-form.expanded-layout .asset-reference-group {
  padding: 9px 10px;
}

.generate-form.expanded-layout .asset-thumb,
.generate-form.expanded-layout .asset-add-btn,
.generate-form.expanded-layout .asset-add-btn :deep(.el-upload) {
  width: 44px;
  height: 44px;
}

.generate-form.expanded-layout .asset-index-badge {
  width: 12px;
  height: 12px;
  font-size: 8px;
  border-radius: 3px;
  left: 2px;
  bottom: 2px;
}

.generate-form.expanded-layout .asset-audio-thumb {
  width: 44px;
  min-width: 44px;
  max-width: 44px;
  height: 44px;
}

.prompt-section-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 6px 4px 0;
  font-size: 12px;
  color: #909399;
}

.prompt-char-count { user-select: none; }

.prompt-clear-footer {
  cursor: pointer;
  font-size: 15px;
  color: #c0c4cc;
  transition: color 0.2s;
}

.prompt-clear-footer:hover { color: #f56c6c; }

/* === Settings card (expanded right column) === */
.settings-card-expanded {
  display: flex;
  flex-direction: column;
  background: #f7f9fb;
  border-radius: 12px;
  padding: 14px 16px 16px;
  border: 1px solid #edf0f5;
  height: 100%;
  box-sizing: border-box;
}

.settings-card-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.setting-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 14px;
  background: #fff;
  border: 1px solid #e6e9ee;
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.18s, box-shadow 0.18s;
  user-select: none;
}

.setting-row:hover {
  border-color: #1875F0;
  box-shadow: 0 0 0 2px rgba(24, 117, 240, 0.08);
}

.setting-row-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.setting-row-label {
  font-size: 12px;
  color: #909399;
  line-height: 1.3;
}

.setting-row-value {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.setting-row-arrow {
  font-size: 12px;
  color: #c0c4cc;
  flex-shrink: 0;
  margin-left: 8px;
}

.segment-panel {
  padding: 7px 9px 8px;
  background: #fff;
  border: 1px solid #e6e9ee;
  border-radius: 10px;
  transition: border-color 0.18s, box-shadow 0.18s;
}

.segment-panel:hover {
  border-color: #1875F0;
  box-shadow: 0 0 0 2px rgba(24, 117, 240, 0.08);
}

.segment-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 5px;
}

.segment-value-pill {
  min-width: 64px;
  padding: 1px 8px;
  border-radius: 999px;
  background: #f3f6fb;
  color: #4b5563;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
  white-space: nowrap;
}

.segment-control {
  position: relative;
  display: grid;
  grid-template-columns: repeat(var(--segment-count), minmax(0, 1fr));
  gap: 0;
  min-height: 32px;
  padding: 2px;
  border-radius: 9px;
  background: #f2f5f9;
  border: 1px solid #e8edf5;
  overflow: hidden;
}

.segment-indicator {
  position: absolute;
  inset: 2px auto 2px 2px;
  border-radius: 7px;
  background: linear-gradient(135deg, #1875F0 0%, #00A9FF 100%);
  box-shadow: 0 4px 10px rgba(24, 117, 240, 0.22);
  transition: transform 0.2s ease, width 0.2s ease;
}

.segment-option {
  position: relative;
  z-index: 1;
  min-width: 0;
  min-height: 28px;
  padding: 3px 3px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  transition: color 0.18s ease;
}

.segment-option + .segment-option::before {
  content: '';
  position: absolute;
  left: 0;
  top: 6px;
  bottom: 6px;
  width: 1px;
  background: rgba(148, 163, 184, 0.28);
}

.segment-option.active {
  color: #fff;
}

.segment-option.active::before,
.segment-option.active + .segment-option::before {
  opacity: 0;
}

.segment-option:disabled {
  cursor: not-allowed;
}

.model-segment-option {
  flex-direction: row;
}

.model-segment-label {
  display: block;
  max-width: 100%;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.size-segment-quality {
  display: block;
  max-width: 100%;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.size-segment-orientation {
  display: block;
  max-width: 100%;
  font-size: 9px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.86;
}

.duration-setting-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.duration-setting-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.duration-setting-title {
  color: #303133;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.25;
}

.duration-value-pill {
  width: 56px;
  min-width: 56px;
  max-width: 56px;
  flex: 0 0 56px;
  height: 28px;
  padding: 0 10px;
  box-sizing: border-box;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  background: #f1f3f6;
  color: #303133;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
}

.duration-value-input {
  appearance: none;
  -webkit-appearance: none;
  border: 0;
  outline: none;
  cursor: text;
  font-family: inherit;
  line-height: 28px;
  vertical-align: middle;
  transition: background 0.18s ease, box-shadow 0.18s ease;
}

.duration-value-input:hover,
.duration-value-input:focus {
  background: #eaf3ff;
  box-shadow: inset 0 0 0 1px rgba(24, 117, 240, 0.18);
}

.duration-value-input:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.duration-value-wrap {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.duration-value-pill strong {
  color: #303133;
  font-size: 15px;
  font-weight: 700;
}

.duration-value-unit {
  color: #8f96a3;
  font-size: 11px;
  font-weight: 500;
}

.duration-ruler {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  margin-top: 0;
  padding: 0;
}

.duration-control-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.duration-range-input {
  width: 100%;
  height: 25px;
  margin: 0;
  appearance: none;
  -webkit-appearance: none;
  background: transparent;
  cursor: pointer;
  display: block;
  touch-action: pan-y;
}

.duration-range-input:disabled {
  cursor: not-allowed;
}

.duration-range-input::-webkit-slider-runnable-track {
  height: 6px;
  border-radius: 999px;
  background: linear-gradient(90deg, #1875F0 0%, #00C6FF var(--duration-progress), #e3e7ee var(--duration-progress), #e3e7ee 100%);
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.08);
}

.duration-range-input::-webkit-slider-thumb {
  width: 16px;
  height: 16px;
  margin-top: -5px;
  appearance: none;
  -webkit-appearance: none;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #1875F0;
  box-shadow: 0 2px 7px rgba(24, 117, 240, 0.38);
  transition: transform 0.16s ease, box-shadow 0.16s ease;
}

.duration-range-input:hover::-webkit-slider-thumb {
  transform: scale(1.08);
  box-shadow: 0 6px 14px rgba(24, 117, 240, 0.42);
}

.duration-range-input:focus-visible {
  outline: none;
}

.duration-range-input:focus-visible::-webkit-slider-thumb {
  box-shadow: 0 0 0 4px rgba(24, 117, 240, 0.16), 0 4px 10px rgba(24, 117, 240, 0.35);
}

.duration-range-input::-moz-range-track {
  height: 6px;
  border-radius: 999px;
  background: #e3e7ee;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.08);
}

.duration-range-input::-moz-range-progress {
  height: 6px;
  border-radius: 999px;
  background: linear-gradient(90deg, #1875F0 0%, #00C6FF 100%);
}

.duration-range-input::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #1875F0;
  box-shadow: 0 4px 10px rgba(24, 117, 240, 0.35);
}

.duration-setting-tag {
  min-width: 53px;
  justify-content: center;
  color: #4f5968;
  background: #f1f3f6;
  border-color: #e4e7ed;
}

.duration-setting-tag:hover {
  color: #1875F0;
  background: #ecf5ff;
  border-color: #b3d8ff;
}

:global(.duration-options-popover) {
  max-width: calc(100vw - 24px);
}

.duration-tick-row {
  position: relative;
  height: 21px;
  margin-top: -2px;
}

.duration-tick-row::before {
  content: '';
  position: absolute;
  top: 3px;
  left: 0;
  right: 0;
  height: 1px;
  background: #edf1f7;
}

.duration-tick {
  position: absolute;
  top: 0;
  width: 24px;
  min-width: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #a8b0bd;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-size: 10px;
  line-height: 1;
  transform: translateX(-50%);
}

.duration-tick:disabled {
  cursor: not-allowed;
}

.duration-tick-mark {
  width: 1px;
  height: 8px;
  border-radius: 999px;
  background: currentColor;
  opacity: 0.75;
  transition: height 0.16s ease, opacity 0.16s ease, color 0.16s ease;
}

.duration-tick-label {
  display: block;
  min-width: 12px;
  text-align: center;
  transform-origin: top center;
  transition: color 0.16s ease, transform 0.16s ease;
}

.duration-tick.active {
  color: #60a5fa;
}

.duration-tick.selected {
  color: #1875F0;
  font-weight: 700;
}

.duration-tick.selected .duration-tick-mark {
  height: 11px;
  opacity: 1;
  width: 2px;
}

.duration-tick.selected .duration-tick-label {
  transform: translateY(1px);
}

.duration-fixed-ruler {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  height: 20px;
  margin-top: 0;
  display: flex;
  align-items: center;
}

.duration-fixed-track {
  width: 100%;
  height: 5px;
  border-radius: 999px;
  background: linear-gradient(90deg, #1875F0 0%, #00C6FF 100%);
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.08);
}

.duration-fixed-thumb {
  position: absolute;
  right: 0;
  width: 15px;
  height: 15px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #1875F0;
  box-shadow: 0 4px 10px rgba(24, 117, 240, 0.35);
}

.generate-button-large {
  margin-top: 12px;
  height: 48px;
  border-radius: 10px;
  background: linear-gradient(90deg, #1875F0 0%, #00C6FF 100%);
  border: none;
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  box-shadow: 0 4px 12px rgba(24, 117, 240, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: transform 0.25s ease, box-shadow 0.25s ease, opacity 0.25s ease;
  width: 100%;
}

.generate-button-large .gbl-icon { font-size: 18px; }

.generate-button-large:hover {
  background: linear-gradient(90deg, #00C6FF 0%, #1875F0 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(24, 117, 240, 0.35);
}

.generate-button-large.is-disabled,
.generate-button-large:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
}

/* expanded mode container padding tweak */
.generate-container .generate-form.expanded-layout {
  width: 100%;
}

.settings-section.has-platform-warning { flex-wrap: wrap; }
.settings-section.has-platform-warning .settings-summary { flex-basis: 0; }
.no-platform-text {
  order: 4;
  flex: 0 0 100%;
  min-width: 0;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.5;
  color: #d93025;
  white-space: normal;
  overflow-wrap: anywhere;
}



.seedance-assets-bar {
  width: 100%;
  order: 1;
  flex: 0 0 auto;
  max-height: 76px;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: hidden;
  overflow-x: hidden;
}

.asset-group {
  display: grid;
  grid-template-columns: 76px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 9px 10px;
  background: #fafbfc;
  border-radius: 10px;
  border: 1px solid #edf0f5;
  position: relative;
}

.asset-reference-group {
  display: block;
}

.asset-group::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10px;
  bottom: 10px;
  width: 3px;
  border-radius: 0 999px 999px 0;
  z-index: 2;
}

.asset-group[data-type="image"]::before { background: #1875F0; }

.asset-group[data-type="video"]::before { background: #7c3aed; }

.asset-group[data-type="audio"]::before { background: #10b981; }

.asset-group::after {
  content: '';
  position: absolute;
  top: 9px;
  right: 10px;
  bottom: 14px;
  width: 26px;
  background: linear-gradient(to right, transparent, #fafbfc 82%);
  pointer-events: none;
  z-index: 3;
  border-radius: 0 9px 9px 0;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.asset-group.has-scroll:not(.scroll-end)::after { opacity: 1; }

.asset-clear-inline {
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: #fff;
  color: #c0c4cc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  cursor: pointer;
  box-shadow: inset 0 0 0 1px #eef2f7;
  transition: color 0.18s ease, background 0.18s ease, transform 0.18s ease;
}

.asset-clear-inline:hover {
  color: #f56c6c;
  background: rgba(245, 108, 108, 0.1);
  transform: scale(1.04);
}

.asset-items {
  display: flex;
  gap: 7px;
  flex-wrap: nowrap;
  align-items: center;
  min-width: 0;
  padding: 1px 2px 6px 0;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.45) transparent;
}

.asset-items::-webkit-scrollbar {
  height: 5px;
}

.asset-items::-webkit-scrollbar-track {
  background: transparent;
}

.asset-items::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.45);
  border-radius: 999px;
}

.asset-items::-webkit-scrollbar-thumb:hover {
  background: rgba(100, 116, 139, 0.62);
}

.asset-group.has-scroll .asset-items { cursor: ew-resize; }

.asset-thumb {
  position: relative;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  overflow: visible;
  border: 2px solid var(--reference-color, #e4e7ed);
  background: #f5f7fa;
  flex-shrink: 0;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
  box-sizing: border-box;
}

.asset-thumb-image { --reference-color: #43a773; }

.asset-thumb-video { --reference-color: #1875f0; }

.asset-thumb-audio { --reference-color: #9468c0; }

.asset-index-badge {

  position: absolute;

  bottom: 2px;

  left: 2px;

  width: 12px;

  height: 12px;

  border-radius: 3px;

  background: var(--reference-color, #1875f0);

  color: #fff;

  font-size: 8px;

  line-height: 1;

  font-weight: 600;

  display: flex;

  align-items: center;

  justify-content: center;

  box-shadow: 0 1px 3px rgba(0,0,0,0.2);

  pointer-events: none;

}

.asset-type-icon {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  border-radius: 6px;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  pointer-events: none;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.22);
  z-index: 2;
}

.asset-type-image { background: var(--reference-color); }

.asset-type-video { background: var(--reference-color); }

.asset-type-audio { background: var(--reference-color); }

.asset-thumb.asset-unused {

  box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.25);

  animation: asset-pulse 1.8s ease-in-out infinite;

}

.asset-thumb.asset-unused .asset-index-badge {

  background: #f56c6c;

}

@keyframes asset-pulse {

  0%, 100% { box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.15); }

  50% { box-shadow: 0 0 0 4px rgba(245, 108, 108, 0.35); }

}



.volc-asset-badge {

  position: absolute;

  top: -3px;

  right: -3px;

  background: #e6a23c;

  color: #fff;

  font-size: 8px;

  padding: 1px 4px;

  border-radius: 4px;

  pointer-events: none;

  font-weight: 600;

  box-shadow: 0 1px 3px rgba(0,0,0,0.2);

}



.mention-badge.volc-badge,
.mention-badge.local-badge {
  background: var(--mention-badge-bg, #f1f4f8);
  color: var(--mention-badge-text, #596b82);
  border: 1px solid var(--mention-badge-border, #dce4ed);
  font-size: 10px;
  font-weight: 600;
  line-height: 16px;
  padding: 1px 6px;
  border-radius: 5px;
  margin-left: 4px;
  white-space: nowrap;
}

.mention-badge-person {
  --mention-badge-bg: #fff6e8;
  --mention-badge-text: #92601e;
  --mention-badge-border: #efdbb9;
}

.mention-badge-portrait {
  --mention-badge-bg: #edf7f2;
  --mention-badge-text: #35765b;
  --mention-badge-border: #cde5d8;
}

.mention-badge-video {
  --mention-badge-bg: #eef4ff;
  --mention-badge-text: #3c68a7;
  --mention-badge-border: #d2e0f5;
}

.mention-badge-audio {
  --mention-badge-bg: #f5f0fb;
  --mention-badge-text: #7955a2;
  --mention-badge-border: #e2d6ef;
}

.asset-thumb.highlight-flash {

  animation: flash-highlight 0.6s ease;

}

@keyframes flash-highlight {

  0% { box-shadow: 0 0 0 0 rgba(24, 117, 240, 0); }

  30% { box-shadow: 0 0 0 4px rgba(24, 117, 240, 0.5); }

  100% { box-shadow: 0 0 0 0 rgba(24, 117, 240, 0); }

}

.asset-thumb > .reference-thumbnail {
  border-radius: 6px;
  overflow: hidden;
}

.asset-thumb :deep(img), .asset-thumb :deep(video) {

  width: 100%;

  height: 100%;

  object-fit: cover;

  border-radius: 6px;

  display: block;

}

.asset-thumb-overlay {

  position: absolute;

  inset: 0;

  background: rgba(0,0,0,0.45);

  display: flex;

  align-items: center;

  justify-content: center;

  color: #fff;

  font-size: 16px;

  opacity: 0;

  transition: opacity 0.2s;

  cursor: pointer;

  border-radius: 7px;

}

.asset-thumb:hover .asset-thumb-overlay { opacity: 1; }

.asset-thumb-uploading {

  position: absolute;

  inset: 0;

  background: rgba(0,0,0,0.3);

  display: flex;

  align-items: center;

  justify-content: center;

  color: #fff;

  font-size: 18px;

  border-radius: 7px;

}

.asset-audio-thumb {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 44px;
  min-width: 44px;
  max-width: 44px;
  height: 44px;
  background: linear-gradient(180deg, #fcfaff 0%, #f2ebfa 100%);
}

.audio-icon { font-size: 18px; color: #7046a5; flex-shrink: 0; }

.asset-video-thumb {

  width: 100%;

  height: 100%;

  object-fit: cover;

  border-radius: 7px;

}

.asset-add-btn {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
}

.asset-add-btn :deep(.el-upload) {
  width: 44px;
  height: 44px;
  border: 1.5px dashed #cfd5e3;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  background: #fff;
  box-sizing: border-box;
}

.asset-add-btn :deep(.el-upload):hover {

  border-color: #1875F0;

  background: #f0f7ff;

}

.asset-add-inner {

  display: flex;

  flex-direction: column;

  align-items: center;

  gap: 2px;

  color: #94a3b8;

  font-size: 11px;

}

.asset-add-inner .el-icon { font-size: 18px; }



.prompt-input-wrapper { flex: 1; display: flex; align-items: center; gap: 12px; position: relative; }



/* === @提及菜单样式：由于使用 fixed 定位，无需脱离文档流但必须设置高层级 === */

.mention-list-popover {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow-anchor: none;

  position: fixed; /* 完全使用基于屏幕视口的定位 */

  width: 240px;

  max-height: 220px;

  overflow: hidden;

  background: #ffffff;

  border: 1px solid #e4e7ed;

  border-radius: 8px;

  box-shadow: 0 6px 16px rgba(0,0,0,0.1);

  z-index: 999999;

  padding: 0;

}

.mention-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  box-sizing: border-box;
  height: 36px;
  padding: 0 8px 0 12px;
  border-bottom: 1px solid #edf0f4;
  color: #748093;
  font-size: 12px;
}

.mention-refresh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #728198;
  cursor: pointer;
}

.mention-refresh:hover:not(:disabled) { color: #526f9a; background: #edf2f8; }
.mention-refresh:focus-visible { outline: 2px solid #8da8ce; outline-offset: 1px; }
.mention-refresh:disabled { opacity: 0.55; cursor: wait; }

.mention-list-body { min-height: 0; overflow-y: auto; overflow-anchor: none; padding: 6px 0; }
.mention-list-status { padding: 10px 12px; color: #909399; font-size: 12px; }
.mention-list-status.is-error { color: #b56753; }

.mention-list-body::-webkit-scrollbar { width: 4px; }

.mention-list-body::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.1); border-radius: 2px; }



.mention-media-preview {

  position: fixed;

  z-index: 1000000;

  background: #fff;

  border: 2px solid #fff;

  border-radius: 12px;

  cursor: pointer;

  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);

  overflow: hidden;

}

.mention-media-preview.has-reference-name {
  padding-top: 32px;
}

.preview-reference-name {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 32px;
  padding: 0 10px;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 32px;
  font-size: 12px;
  font-weight: 500;
  color: #303133;
  cursor: default;
}

.mention-media-preview.mention-menu {
  overflow: visible;
}

/* Keep the short path from a list row to the interactive preview hoverable. */
.mention-media-preview.mention-menu::before,
.mention-media-preview.mention-menu::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 12px;
}
.mention-media-preview.mention-menu::before { left: -12px; }
.mention-media-preview.mention-menu::after { right: -12px; }

.mention-media-preview.chip,
.mention-media-preview.asset-thumb-preview {

  pointer-events: auto;

  overflow: visible;

}

.mention-media-preview.chip::before,
.mention-media-preview.chip::after,
.mention-media-preview.asset-thumb-preview::before,
.mention-media-preview.asset-thumb-preview::after {

  content: '';

  position: absolute;

  left: -12px;

  right: -12px;

  height: 18px;

  background: transparent;

  pointer-events: auto;

}

.mention-media-preview.chip::before,
.mention-media-preview.asset-thumb-preview::before {

  top: -18px;

}

.mention-media-preview.chip::after,
.mention-media-preview.asset-thumb-preview::after {

  bottom: -18px;

}

.mention-media-preview .preview-img {
  /* Dimensions come from the loaded image ratio; no square letterbox. */
  object-fit: contain;

  display: block;

  background: #f5f7fa;

  border-radius: 10px;

}

.mention-media-preview .preview-video {

  width: 320px;

  height: 180px;

  display: block;

  background: #000;

  border-radius: 10px;

}

.preview-unavailable {
  width: 120px;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px;
  box-sizing: border-box;
  background: #f5f7fa;
  color: #909399;
  font-size: 12px;

  border-radius: 10px;
}

.mention-media-preview.video .preview-unavailable {
  width: 160px;
  height: 90px;
}

.mention-media-preview.audio .preview-unavailable {
  width: 150px;
  height: 32px;
  flex-direction: row;
  gap: 4px;
  padding: 4px 8px;
  font-size: 12px;
}

.preview-unavailable-icon {
  font-size: 16px;
  color: #c0c4cc;
}

.preview-audio-wrapper {

  display: flex;

  align-items: center;

  gap: 10px;

  padding: 12px 16px;

  min-width: 300px;

  border-radius: 10px;

}

.preview-audio-icon {

  font-size: 28px;

  color: #1875F0;

  flex-shrink: 0;

}

.preview-audio {

  flex: 1;

  height: 36px;

  min-width: 200px;

}



.mention-item {
  height: 46px;
  box-sizing: border-box;

  padding: 8px 12px;

  cursor: pointer;

  display: flex;

  align-items: center;

  justify-content: flex-start;

  gap: 8px;

  font-size: 13px;

  color: #303133;

  transition: all 0.2s;

  border: 1px solid transparent; 

  margin: 0 4px;

  border-radius: 6px;

}

.mention-item:hover, .mention-item.active {

  background-color: #e6f7ff;

  border-color: #1875F0;

  box-shadow: 0 2px 8px rgba(24, 117, 240, 0.1);

}

.mention-uuid {

  flex: 1 1 auto;

  min-width: 0;

  max-width: none;

  overflow: hidden;

  text-overflow: ellipsis;

  white-space: nowrap;

  text-align: left;

  font-weight: 600;

  color: #1875F0;

}

.mention-info { font-size: 12px; color: #909399; flex-shrink: 0; }



.mention-thumb {

  width: 28px;

  height: 28px;

  border-radius: 4px;

  object-fit: cover;

  flex-shrink: 0;

}

.mention-badge {

  font-size: 11px;

  padding: 1px 6px;

  border-radius: 4px;

  background: #ecf5ff;

  color: #1875F0;

  flex-shrink: 0;

}

.mention-audio-icon {

  font-size: 20px;

  color: #1875F0;

  flex-shrink: 0;

}



.rich-textarea {

  width: 100%; 

  height: 100%; 

  min-height: 0;

  border: none; 

  background: transparent; 

  outline: none;

  font-family: inherit; 

  font-size: 16px; 

  line-height: 1.6; 

  color: #111827;

  padding: 8px 0 8px 12px;

  box-sizing: border-box; 

  display: block; 

  font-weight: 500; 

  caret-color: #1875F0;

  overflow-y: auto;

  white-space: pre-wrap; 

  word-break: break-word;

}

.input-inner-wrapper:not(.expanded) .rich-textarea { padding: 8px 32px 8px 12px; white-space: nowrap; overflow: hidden; }

.rich-textarea.transparent-text { opacity: 0; pointer-events: none; }



.rich-placeholder {

  position: absolute;

  top: 8px;

  left: 12px;

  font-size: 16px;

  color: #9ca3af;

  pointer-events: none;

  user-select: none;

}



.rich-textarea::-webkit-scrollbar { width: 6px; }

.rich-textarea::-webkit-scrollbar-track { background: transparent; }

.rich-textarea::-webkit-scrollbar-thumb { background: rgba(0, 0, 0, 0.1); border-radius: 3px; transition: background 0.3s; }

.rich-textarea::-webkit-scrollbar-thumb:hover { background: rgba(0, 0, 0, 0.2); }



:deep(.mention-chip) {

  display: inline-flex;

  align-items: center;

  justify-content: center;

  box-sizing: border-box;

  color: #1875F0;

  background-color: #e6f7ff;

  border: 1px solid #1875F0;

  border-radius: 4px;

  padding: 1px 4px;

  margin: 0 1px 0 3px;

  font-size: 13px;

  line-height: 18px;

  vertical-align: middle;

  position: relative;

  top: -1px;

  cursor: default;

  user-select: none; 

  pointer-events: auto;

}



:deep(.mention-chip[data-mention-type="image"]) {
  color: #187747;
  background-color: #e7f6ed;
  border-color: #43a773;
}

:deep(.mention-chip[data-mention-type="audio"]) {
  color: #7046a5;
  background-color: #f2ebfa;
  border-color: #9468c0;
}

:deep(.mention-chip[data-mention-type="video"]) {
  color: #1875f0;
  background-color: #e6f7ff;
  border-color: #1875f0;
}

:deep(.mention-chip-icon) {
  display: block;
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  margin-right: 3px;
  border-radius: 2px;
  object-fit: contain;
  pointer-events: none;
}

:deep(.mention-chip[data-mention-type="image"] .mention-chip-icon) {
  object-fit: cover;
  background: #ccebd9;
}

:deep(.mention-chip-image-placeholder) {
  background: linear-gradient(145deg, #ccebd9 50%, #43a773 51%);
}

:deep(.mention-chip-label) {
  display: block;
  line-height: 1;
  transform: translateY(-0.5px);
  white-space: nowrap;
}

.upload-button-container { width: 50px; height: 50px; flex-shrink: 0; position: relative; display: flex; align-items: center; justify-content: center; z-index: 20; margin-right: 4px; }

.image-preview-wrapper { position: absolute; inset: 0; width: 44px; height: 44px; margin: auto; border-radius: 50%; overflow: hidden; cursor: pointer; border: 1.5px solid #dcdfe6; background: #fff; z-index: 10; box-shadow: 0 2px 6px rgba(0,0,0,0.05); transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1); }

.image-preview-wrapper.hide-preview { opacity: 0; transform: scale(0.6); pointer-events: none; }

.image-preview { width: 100%; height: 100%; object-fit: cover; }

.preview-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; color: #fff; font-size: 16px; opacity: 0; transition: opacity 0.2s; }

.image-preview-wrapper:hover .preview-overlay { opacity: 1; }

.upload-icon-button { width: 44px; height: 44px; border: 1.5px dashed #cfd5e3; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #94a3b8; transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); cursor: pointer; font-size: 20px; box-shadow: 0 2px 4px rgba(0,0,0,0.02); }

.upload-icon-button:hover { border-color: #1875F0; color: #1875F0; background: #f0f7ff; transform: translateY(-1px); box-shadow: 0 4px 10px rgba(24, 117, 240, 0.15); }

.custom-spin { animation: rotating 2s linear infinite; }

.prompt-input-container { flex: 1; position: relative; min-height: 42px; z-index: 10; }

.input-inner-wrapper { position: absolute; left: 0; right: 0; bottom: 0; height: 42px; display: flex; flex-direction: column; background: #ffffff; border: 1px solid #dcdfe6; border-radius: 10px; transition: height 0.3s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.3s ease, border-color 0.3s ease, padding 0.3s ease; overflow: visible; box-sizing: border-box; }

.input-inner-wrapper.expanded { z-index: 100; box-shadow: none; border-color: #409EFF; padding: 12px; gap: 12px; }

.input-inner-wrapper:not(.expanded) { padding: 0; gap: 0; }

.remark-tab-bar { position: absolute; top: -30px; right: 12px; height: 30px; max-width: 260px; display: flex; align-items: center; padding: 0 12px; background: #ffffff; border: 1px solid #dcdfe6; border-bottom: none; border-radius: 8px 8px 0 0; cursor: pointer; z-index: 20; transition: border-color 0.3s ease; }

.remark-tab-bar.active { border-color: #409EFF; }

.tab-bottom-mask { position: absolute; bottom: -2px; left: 0; width: 100%; height: 4px; background: #ffffff; z-index: 21; }

.tab-content { position: relative; z-index: 22; display: flex; align-items: center; gap: 6px; font-size: 12px; color: #606266; width: 100%; overflow: hidden; }

.remark-text { flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: 500; }

.remark-icon { color: #909399; flex-shrink: 0; }

.remark-tab-bar:hover .remark-icon { color: #409EFF; }

.remark-tab-bar:hover .remark-text { color: #303133; }

.expanded-preview-area { width: 100%; display: flex; justify-content: center; align-items: center; margin-bottom: 4px; display: none; opacity: 0; transform: translateY(10px); transition: opacity 0.3s ease, transform 0.3s ease; }

.expanded-preview-area.visible { display: flex; opacity: 1; transform: translateY(0); }

.big-preview-card { position: relative; display: inline-block; max-width: 100%; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.1); background: #f5f7fa; }

.big-preview-img { display: block; max-width: 100%; max-height: 220px; object-fit: contain; }

.big-preview-close { position: absolute; top: 6px; right: 6px; width: 24px; height: 24px; background: rgba(0,0,0,0.6); color: #fff; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 14px; cursor: pointer; transition: all 0.2s; backdrop-filter: blur(2px); }

.big-preview-close:hover { background: #f56c6c; transform: scale(1.1); }

.big-preview-loading { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(0,0,0,0.35); color: #fff; font-size: 20px; z-index: 10; }

.textarea-box { flex: 1; position: relative; min-height: 24px; display: flex; align-items: center; }

.prompt-section .textarea-box {
  min-height: 0;
  overflow: hidden;
}

.prompt-text-ellipsis { position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: block; padding: 8px 32px 8px 12px; box-sizing: border-box; font-size: 16px; line-height: 1.6; color: #111827; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; pointer-events: none; user-select: none; z-index: 5; transition: opacity 0.2s ease; }

.prompt-text-ellipsis :deep(.mention-chip) { pointer-events: none; }

.clear-btn { position: absolute; right: 8px; bottom: 8px; color: #c0c4cc; cursor: pointer; font-size: 16px; z-index: 10; display: flex; align-items: center; justify-content: center; width: 20px; height: 20px; }

.input-inner-wrapper:not(.expanded) .clear-btn { top: 50%; transform: translateY(-50%); bottom: auto; }

.clear-btn:hover { color: #909399; }

.settings-btn { width: 40px; height: 40px; font-size: 18px; border: 1px solid #dcdfe6; background: #fff; color: #606266; flex-shrink: 0; transition: all 0.3s; }

.settings-btn:hover { background: #f2f3f5; color: #409EFF; border-color: #409EFF; }

.settings-toggle-btn {
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  background: #fff;
  color: #606266;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  cursor: pointer;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.settings-toggle-btn .el-icon {
  font-size: 18px;
}

.settings-toggle-btn:hover,
.settings-toggle-btn.active {
  color: #1875F0;
  border-color: #1875F0;
  background: #ecf5ff;
}

.settings-toggle-btn.active {
  box-shadow: 0 2px 8px rgba(24, 117, 240, 0.12);
}

.settings-section.settings-collapsed .generate-button {
  margin-left: auto;
}

.settings-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
}

.settings-tags {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
  width: 100%;
  min-width: 0;
}

.settings-tag {

  display: inline-flex; align-items: center; gap: 4px; padding: 4px 8px; font-size: 13px;
  flex: 0 1 auto;
  min-width: 0;
  box-sizing: border-box;

  color: #606266; background: #f5f7fa; border: 1px solid #e4e7ed; border-radius: 6px;

  white-space: nowrap; line-height: 1.6; font-weight: 500;

}

.settings-tag-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.duration-setting-tag {
  flex-shrink: 0;
}

.platform-brand-logo {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  object-fit: contain;
}

/* Reduce control spacing before truncating model and resolution labels. */
@container (max-width: 420px) {
  .settings-tags { gap: 4px; }
  .settings-tag { padding-inline: 4px; }
  .settings-toggle-btn { width: 36px; }
  .settings-section .generate-button { min-width: 64px; padding-inline: 12px; }
}

.settings-tag.clickable {

  cursor: pointer;
  transition: all 0.2s;
}

.settings-tag.clickable:hover {

  color: #1875F0;
  border-color: #1875F0;
  background: #ecf5ff;
}

.tag-option-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
  padding: 10px 12px;
  min-width: 200px;
  max-width: 320px;
}

.tag-option-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 13px;
  color: #606266;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  transition: all 0.18s;
  white-space: nowrap;
  user-select: none;
  text-align: center;
}

.tag-option-item:hover {
  background: #ecf5ff;
  color: #1875F0;
  border-color: #a0cfff;
}

.tag-option-item.active {
  color: #fff;
  background: #1875F0;
  border-color: #1875F0;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(24, 117, 240, 0.3);
}

.resolution-option-list {
  grid-template-columns: repeat(2, minmax(104px, 1fr));
  min-width: 232px;
  max-width: 300px;
}

.resolution-option-card {
  flex-direction: column;
  gap: 4px;
  min-height: 72px;
  padding: 7px 8px;
  border-radius: 7px;
}

.resolution-option-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 32px;
  flex: 0 0 32px;
}

.resolution-option-shape {
  display: block;
  box-sizing: border-box;
  flex: none;
  border: 1.5px solid currentColor;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.56);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.4);
}

.resolution-option-label {
  line-height: 18px;
  white-space: nowrap;
}

.platform-option-list {
  grid-template-columns: 1fr;
  gap: 6px;
  min-width: 260px;
  max-width: 300px;
  padding: 8px;
}

.platform-option-row {
  justify-content: flex-start;
  gap: 10px;
  min-height: 48px;
  padding: 7px 10px;
  border-radius: 8px;
  text-align: left;
}

.platform-option-row:hover {
  background: #f1f6fc;
  border-color: #c9dcf2;
  color: #315f8d;
}

.platform-option-row.active {
  color: #245b91;
  background: #eaf3fd;
  border-color: #b9d4f1;
  box-shadow: inset 3px 0 0 #1875F0;
}

.platform-setting-tag.platform-disabled,
.platform-option-row.platform-disabled {
  color: #d93025;
  background: #fff1f0;
  border-color: #f89898;
  box-shadow: none;
}

.platform-option-row.platform-disabled {
  cursor: not-allowed;
}

.platform-option-row.platform-preview-disabled {
  color: #999;
  background: #f5f5f5;
  border-color: #e5e5e5;
  opacity: .6;
}

.platform-preview-disabled .platform-option-icon {
  filter: grayscale(1);
}

.platform-disabled-badge {
  flex-shrink: 0;
  padding: 1px 5px;
  border-radius: 4px;
  background: #d93025;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.platform-option-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  border: 1px solid #dce6f1;
  border-radius: 7px;
  color: #52779b;
  background: #f0f4f8;
}

.platform-option-icon .platform-brand-logo {
  width: 24px;
  height: 24px;
  flex-basis: 24px;
}

.platform-icon-wan {
  color: #317b73;
  background: #edf7f5;
  border-color: #d3e9e5;
}

.platform-option-name {
  min-width: 0;
  overflow: hidden;
  color: inherit;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.settings-tag.resolution-tone-480,
.tag-option-item.resolution-tone-480 {
  color: #3f7650;
  background: #eef8f1;
  border-color: #cfe7d5;
}

.settings-tag.resolution-tone-720,
.tag-option-item.resolution-tone-720 {
  color: #356a9a;
  background: #edf5ff;
  border-color: #c9ddf5;
}

.settings-tag.resolution-tone-1080,
.tag-option-item.resolution-tone-1080 {
  color: #856629;
  background: #fff7e8;
  border-color: #eeddb8;
}

.settings-tag.clickable.resolution-tone-480:hover,
.tag-option-item.resolution-tone-480:hover,
.tag-option-item.resolution-tone-480.active {
  color: #316a43;
  background: #e3f3e8;
  border-color: #acd4b8;
  box-shadow: none;
}

.settings-tag.clickable.resolution-tone-720:hover,
.tag-option-item.resolution-tone-720:hover,
.tag-option-item.resolution-tone-720.active {
  color: #285f91;
  background: #e1efff;
  border-color: #a9ccef;
  box-shadow: none;
}

.settings-tag.clickable.resolution-tone-1080:hover,
.tag-option-item.resolution-tone-1080:hover,
.tag-option-item.resolution-tone-1080.active {
  color: #76591f;
  background: #fff1d7;
  border-color: #e4cc98;
  box-shadow: none;
}

.tag-option-item .check-icon {
  display: none;
}

.generate-button { min-width: 96px; height: 40px; background: linear-gradient(90deg, #1875F0 0%, #00C6FF 100%); border: none; border-radius: 8px; color: #fff; font-weight: 600; font-size: 14px; box-shadow: 0 2px 8px rgba(24, 117, 240, 0.3); transition: all 0.3s ease; flex-shrink: 0; }

.generate-button:hover { background: linear-gradient(90deg, #00C6FF 0%, #1875F0 100%); transform: translateY(-1px); }



@media (max-width: 900px) {

  .generate-container,
  :global(.sidebar-mini) .generate-container {
    top: auto;
    left: 16px;
    right: 16px;
    bottom: 16px;
    width: auto;
    padding: 12px;
    max-width: calc(100% - 32px);
    max-height: calc(100vh - 96px);
    z-index: 1001;
    border-radius: 12px;
    border: 1px solid #1875F0;
    box-shadow: 0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(24, 117, 240, 0.1);
  }

  .generate-resize-handle { display: none; }

  .generate-form { flex-direction: column; gap: 10px; }

  .generate-form.expanded-layout { display: flex; flex-direction: column; }

  .prompt-input-wrapper { width: 100%; }

  .generate-button { width: 100%; }

  .settings-section { flex-direction: row; align-items: center; flex-wrap: nowrap; }

  .settings-summary { position: static; right: auto; top: auto; z-index: auto; flex: 1 1 auto; order: 2; }

  .settings-tags { display: flex; }

  .settings-toggle-btn { order: 1; }

  .generate-button { order: 3; flex: 0 0 auto; width: auto; }

  .upload-button-container { width: 60px; height: 60px; }

}

@keyframes rotating { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

/* ---- Upload as Asset ---- */
.upload-as-asset-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.uaa-target-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.uaa-label {
  font-size: 13px;
  color: #606266;
  flex-shrink: 0;
  white-space: nowrap;
}

.uaa-select-all {
  display: flex;
  align-items: center;
  gap: 12px;
}

.uaa-count {
  font-size: 12px;
  color: #909399;
}

.uaa-item-list {
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.uaa-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 14px;
  border-bottom: 1px solid #f2f4f7;
  transition: background 0.1s;
}

.uaa-item:last-child {
  border-bottom: none;
}

.uaa-item:hover {
  background: #f5f7ff;
}

.uaa-item-check {
  flex-shrink: 0;
}

.uaa-item-thumb {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f6;
}

.uaa-item-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.uaa-item-name-input {
  flex: 1;
  font-size: 13px;
  color: #303133;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 2px 6px;
  background: transparent;
  outline: none;
  transition: all 0.12s;
  min-width: 0;
}
.uaa-item-name-input:hover {
  border-color: #d0d5e3;
  background: #fff;
}
.uaa-item-name-input:focus {
  border-color: #4f6ef7;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(79, 110, 247, 0.1);
}

.uaa-type-tag {
  flex-shrink: 0;
}

.uaa-real-person {
  flex-shrink: 0;
}

.preview-fullscreen-hint {
  position: absolute;
  bottom: 6px;
  right: 6px;
  background: rgba(0,0,0,0.45);
  border-radius: 6px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
  font-size: 14px;
}
.mention-media-preview:hover .preview-fullscreen-hint {
  opacity: 1;
}

</style>



<style>

.preview-fade-enter-active { transition: opacity 0.18s ease-out, transform 0.18s ease-out; }

.preview-fade-leave-active { transition: none; }

.preview-fade-enter-from { opacity: 0; transform: translateY(6px); }

.preview-fade-leave-to { opacity: 0; transform: translateY(4px); }



.custom-remark-dialog { border-radius: 16px !important; overflow: hidden; box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15) !important; }

.custom-remark-dialog .el-dialog__header { padding: 0; margin: 0; }

.custom-remark-dialog .el-dialog__body { padding: 24px; }

.custom-remark-dialog .el-dialog__footer { padding: 16px 24px; background: #f9fafb; border-top: 1px solid #f0f2f5; }

.dialog-header-row { display: flex; justify-content: space-between; align-items: center; padding: 20px 24px 0 24px; }

.header-left { display: flex; align-items: center; gap: 10px; }

.icon-box { width: 32px; height: 32px; border-radius: 8px; background: linear-gradient(135deg, #e6f7ff 0%, #e0f2fe 100%); color: #1875F0; display: flex; align-items: center; justify-content: center; font-size: 16px; }

.header-title { font-size: 18px; font-weight: 600; color: #111827; }

.close-btn { width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #9ca3af; transition: all 0.2s; }

.close-btn:hover { background: #f3f4f6; color: #606266; }

.input-wrapper { background: #f5f7fa; border-radius: 12px; padding: 4px; border: 1px solid transparent; transition: all 0.3s; }

.input-wrapper:focus-within { background: #fff; border-color: #1875F0; box-shadow: 0 0 0 2px rgba(24, 117, 240, 0.1); }

.custom-textarea .el-textarea__inner { background: transparent !important; box-shadow: none !important; border: none !important; padding: 12px; font-size: 14px; color: #333; font-family: monospace; }

.tag-options-popover { transition: none !important; animation: none !important; }
.tag-options-popover.el-popper { transition: none !important; animation: none !important; }
.el-popper.tag-options-popover[data-popper-placement] { transition: none !important; }
.el-fade-in-linear-enter-active.tag-options-popover,
.el-fade-in-linear-leave-active.tag-options-popover { transition-duration: 0ms !important; }

.input-footer { display: flex; justify-content: space-between; padding: 0 12px 8px 12px; font-size: 12px; color: #9ca3af; }

.dialog-footer-row { display: flex; justify-content: flex-end; gap: 12px; }

.cancel-btn { border: none; background: transparent; color: #606266; }

.cancel-btn:hover { background: #f3f4f6; }

.confirm-btn { background: linear-gradient(90deg, #1875F0 0%, #00C6FF 100%); border: none; padding: 8px 24px; border-radius: 8px; font-weight: 500; transition: opacity 0.2s; }

.confirm-btn:hover { opacity: 0.9; transform: translateY(-1px); }

.cascading-settings-popover { padding: 0 !important; border-radius: 12px !important; box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important; border: 1px solid #e5e7eb !important; }

.settings-container { width: 100%; min-width: 260px; background: #fff; border-radius: 12px; overflow: hidden; }

.menu-list { padding: 8px 0; }

.menu-header { padding: 12px 16px 8px 16px; font-size: 14px; font-weight: 600; color: #303133; border-bottom: 1px solid #f0f2f5; margin-bottom: 4px; }

.menu-item { display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; cursor: pointer; transition: all 0.2s ease; user-select: none; }

.menu-item:hover { background: #f5f7fa; }

.menu-label { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #606266; }

.menu-icon { font-size: 16px; color: #909399; }

.menu-value { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #909399; }

.menu-value .el-icon { font-size: 12px; color: #c0c4cc; }

.submenu-list { padding: 0; }

.submenu-header { display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; border-bottom: 1px solid #f0f2f5; background: #fafbfc; }

.back-btn { display: flex; align-items: center; gap: 6px; font-size: 14px; color: #606266; cursor: pointer; transition: color 0.2s; }

.back-btn:hover { color: #1875F0; }

.submenu-title { font-size: 14px; font-weight: 600; color: #303133; flex: 1; text-align: center; }

.placeholder { width: 60px; }

.submenu-content { padding: 8px 0; max-height: 300px; overflow-y: auto; }

.option-item { display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; cursor: pointer; transition: all 0.2s ease; user-select: none; font-size: 14px; color: #606266; }

.option-item:hover { background: #f5f7fa; }

.option-item.active { background: #e6f7ff; color: #1875F0; font-weight: 500; }

.check-icon { font-size: 16px; color: #1875F0; }

.fade-in { animation: fadeIn 0.2s ease-in-out; }

@keyframes fadeIn { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: translateY(0); } }

.submenu-content::-webkit-scrollbar { width: 6px; }

.submenu-content::-webkit-scrollbar-track { background: transparent; }

.submenu-content::-webkit-scrollbar-thumb { background: rgba(0, 0, 0, 0.1); border-radius: 3px; }

/* 全屏预览 */
.fullscreen-preview-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000001; /* Above mention list (999999) and hover preview (1000000). */
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
  cursor: pointer;
  backdrop-filter: blur(4px);
}
.fullscreen-preview-overlay.active {
  opacity: 1;
}
.fullscreen-preview-overlay.closing {
  opacity: 0;
}
.fullscreen-preview-content {
  position: relative;
  cursor: default;
  max-width: 90vw;
  max-height: 90vh;
}
.fullscreen-preview-img {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.4);
}
.fullscreen-preview-video {
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.4);
  background: #000;
}
.fullscreen-preview-audio-wrapper {
  background: #fff;
  border-radius: 12px;
  padding: 24px 32px;
  min-width: 400px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.fullscreen-preview-audio {
  flex: 1;
}
.fullscreen-preview-close {
  position: absolute;
  top: -40px;
  right: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255,255,255,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  transition: background 0.2s;
}
.fullscreen-preview-close:hover {
  background: rgba(255,255,255,0.3);
}

.submenu-content::-webkit-scrollbar-thumb:hover { background: rgba(0, 0, 0, 0.2); }

</style>

<style scoped src="./prompt-panel.css"></style>
<style scoped>
</style>
